const CONTACT_API = {
  // 账号登录
  loginAccount: {
    method: 'get',
    url: 'auth/login/account'
  },
  // 手机号登录
  loginPhone: {
    method: 'get',
    url: 'auth/login/phone'
  },
  // 个人菜单
  userMemu: {
    method: 'get',
    url: 'user/memu'
  },
  //获取联系人列表
  spDelete: {
    method: 'get',
    url: 'sp/delete'
  },
  // 上传文件
  fileUpload: {
    method: 'post',
    url: 'file/upload'
  },
  // SP添加和修改
  spEdit: {
    method: 'post',
    url: 'sp/edit'
  },
  // 老师列表
  teacherList: {
    method: 'get',
    url: 'teacher/list'
  },
  // 老师列表
  teacherList2: {
    method: 'get',
    url: 'teacher/list2'
  },
  // 老师列表
  teacherList3: {
    method: 'get',
    url: 'teacher/list3'
  },
  // 单位管理员添加
  addManager: {
    method: 'get',
    url: 'company/add/manager'
  },
  // 重置密码
  resetPassword: {
    method: 'get',
    url: 'sp/reset/password'
  },
  // 获取登录用户信息
  getUserItem: {
    method: 'get',
    url: 'user/other/info'
  },
  // 获取单位
  getCompanyList: {
    method: 'get',
    url: 'company/list'
  },
  // 修改用户信息
  updataUser: {
    method: 'post',
    url: 'user/info/modify'
  },
  // 修改用户密码
  updataUserPassword: {
    method: 'post',
    url: 'user/password/modify'
  },
  // 查询学科数据
  getXuekeList: {
    method: 'get',
    url: 'subject/list'
  },
  //学生列表
  studentList: {
    method: 'get',
    url: 'student/list'
  },
  // 专业列表
  majorList: {
    method: 'get',
    url: 'major/list'
  },
  // 年级列表
  gradeAll: {
    method: 'get',
    url: 'sys/grade/all'
  },
  // 班级列表
  classList: {
    method: 'get',
    url: 'class/list'
  },
  // 学生添加和修改
  studentEdit: {
    method: 'post',
    url: 'student/edit'
  },
  //删除学生
  studentDelete: {
    method: 'post',
    url: 'student/delete'
  },
  //学生重置密码
  studentPassword: {
    method: 'get',
    url: 'student/reset/password'
  },
  // 学生导出
  studentExport: {
    method: 'get',
    url: 'student/export',
    // responseType: "application/x-download"
  },
  // 学生模版导入
  DownloadTemplate: {
    method: 'get',
    url: 'student/download/template'
  },
  // 学生导入
  studentImport: {
    method: 'post',
    url: 'student/import'
  },
  // 老师目录
  steacherTree: {
    method: 'get',
    url: 'teacher/tree'
  },
  //老师职称
  titleList: {
    method: 'get',
    url: 'user/teacher/title/list'
  },
  // 部门树
  departmentList: {
    method: 'get',
    url: 'department/list'
  },
  // 部门树
  departmentgetMyOneSubDepartmentList: {
    method: 'get',
    url: 'department/getMyOneSubDepartmentList'
  },
  // 老师添加
  teacherEdit: {
    method: 'post',
    url: 'teacher/edit'
  },
  // 老师添加
  teacherPassword: {
    method: 'get',
    url: 'teacher/reset/password'
  },
  // 老师删除
  teacherDelete: {
    method: 'post',
    url: 'teacher/delete'
  },
  // 老师模版导入
  teacherTemplate: {
    method: 'get',
    url: 'teacher/download/template'
  },
  // 老师导入
  teacherImport: {
    method: 'post',
    url: 'teacher/import'
  },
  // 老师导出
  teacherExport: {
    method: 'get',
    url: 'teacher/export'
  },
  // 群组列表
  groupList: {
    method: 'get',
    url: 'group/list'
  },
  // 考试列表
  examList: {
    method: 'get',
    url: 'exam/list'
  },
  // 考试报告
  examListReport: {
    method: 'get',
    url: 'exam/list/report'
  },
  // 考试删除
  examDelete: {
    method: 'get',
    url: 'exam/delete'
  },
  // 病例列表
  caseList: {
    method: 'get',
    url: 'case/list'
  },
  // 病例管理列表
  caseExamList: {
    method: 'get',
    url: 'case/exam/list'
  },
  // 病例管理列表
  casemodel3Dlist: {
    method: 'get',
    url: 'case/model3D/list'
  },
  // 学科列表
  subjectList: {
    method: 'get',
    url: 'subject/list'
  },
  // sp列表
  spList: {
    method: 'get',
    url: 'sp/list'
  },
  // 评分列表
  scoreList: {
    method: 'get',
    url: 'score/table/list'
  },
  // 评分表详情
  scoreDetail: {
    method: 'get',
    url: 'score/table/detail'
  },
  //考试添加和修改
  examEdit: {
    method: 'post',
    url: 'exam/edit'
  },
  // 老师评卷列表
  examTeacherList: {
    method: 'get',
    url: 'exam/score/teacher/list'
  },
  // SP评卷列表
  examSpList: {
    method: 'get',
    url: 'exam/score/sp/list'
  },
  //考试的所有学生列表
  examStudentList: {
    method: 'get',
    url: 'exam/score/room/student/list'
  },
  //点击开始评分或者切换考生
  examChangeStudent: {
    method: 'get',
    url: 'exam/score/change/student'
  },
  //病例详情
  caseDetail: {
    method: 'get',
    url: 'case/detail'
  },
  //提交考生考试结果
  submitStudentScore: {
    method: 'post',
    url: 'exam/score/submit/student/score'
  },
  // 保存学科数据
  saveSubJect: {
    method: 'post',
    url: 'subject/edit'
  },
  // 删除学科数据
  deleteSubject: {
    method: 'get',
    url: 'subject/delete'
  },
  // 获取班级列表数据
  getClassList: {
    method: 'get',
    url: 'class/list'
  },
  // 获取班级左边树
  getClassTree: {
    method: 'get',
    url: 'class/tree'
  },
  // 获取专业下拉数据
  getMajorList: {
    method: 'get',
    url: 'major/list'
  },
  // 获取年级列表数据
  getSysGradeAll: {
    method: 'get',
    url: 'sys/grade/all'
  },
  // 保存班级数据
  saveClassItem: {
    method: 'post',
    url: 'class/edit'
  },
  // 删除班级数据
  deleteClassItem: {
    method: 'post',
    url: 'class/delete'
  },
  // 新增专业
  majorAdd: {
    method: 'post',
    url: 'major/edit'
  },
  // 删除专业
  majorDelete: {
    method: 'get',
    url: 'major/delete'
  },
  // 新增群组
  groupEdit: {
    method: 'post',
    url: 'group/edit'
  },
  // 删除群组
  groupDelete: {
    method: 'get',
    url: 'group/delete'
  },
  // 群组查询学生
  groupStudents: {
    method: 'get',
    url: 'group/students'
  },
  // 群组-学生新增
  groupAddStudent: {
    method: 'post',
    url: 'group/add/student'
  },
  // 学生查询
  studentSearch: {
    method: 'get',
    url: 'student/search'
  },
  // 删除学生
  groupDeleteStudent: {
    method: 'post',
    url: 'group/delete/student'
  },
  // 新增病例
  caseEdit: {
    method: 'post',
    url: 'case/edit'
  },
  // 发布病例
  casePublish: {
    method: 'get',
    url: 'case/publish'
  },
  // 删除病例
  caseDelete: {
    method: 'get',
    url: 'case/delete'
  },
  // 新增菜单
  sysMenuEdit: {
    method: 'post',
    url: 'sys/menu/edit'
  },
  // 查询菜单
  sysMenuList: {
    method: 'get',
    url: 'sys/menu/list'
  },
  // 单位自定义菜单列表
  companyMenuList: {
    method: 'post',
    url: 'sys/menu/company/list'
  },
  // 单位自定义菜单编辑（新增/修改）
  companyMenuEdit: {
    method: 'post',
    url: 'sys/menu/company/edit'
  },
  companyMenuDelete: {
    method: 'get',
    url: 'sys/menu/company/delete'
  },
  // 系统菜单列表
  systemMenuList: {
    method: 'post',
    url: 'sys/menu/openToCompanyList',
  },
  // 删除菜单
  sysMenuDelete: {
    method: 'get',
    url: 'sys/menu/delete'
  },
  // 新增评分表
  scoreTableEdit: {
    method: 'post',
    url: 'score/table/edit'
  },
  // 查询评分表
  scoreTableList: {
    method: 'get',
    url: 'score/table/list'
  },
  // 新增和编辑部门
  departmentEdit: {
    method: 'post',
    url: 'department/edit'
  },
  // 删除部门
  departmentDelete: {
    method: 'get',
    url: 'department/delete'
  },
  // 删除评分表
  scoreTableDelete: {
    method: 'get',
    url: 'score/table/delete'
  },
  // 查询评分表详情
  scoreTableDetailWithListItem: {
    method: 'get',
    url: 'score/table/detailWithListItem'
  },
  // 考试报告
  ReportDetail: {
    method: 'get',
    url: 'exam/report/detail'
  },
  // 考试的操作报告
  OperationReport: {
    method: 'get',
    url: 'exam/report/operation/report'
  },
  // 考试报告学生列表
  examReportStudents: {
    method: 'get',
    url: 'exam/report/students'
  },
  // 批量删除评分表
  scoreTableDeleteList: {
    method: 'post',
    url: 'score/table/delete/list'
  },
  // 获取胜任力模型列表数据
  scoreCompetencyList: {
    method: 'post',
    url: 'score/competency/list'
  },
  // 保存胜任力模型列表数据
  scoreCompetencyEdit: {
    method: 'post',
    url: 'score/competency/edit'
  },
  // 删除胜任力模型列表数据
  scoreCompetencyDelete: {
    method: 'get',
    url: 'score/competency/delete'
  },
  // 新增胜任力模型列表数据
  scoreCompetencyItemAdd: {
    method: 'get',
    url: 'score/competency/item/add'
  },
  // 胜任力模型列表数据详情
  scoreCompetencyDetail: {
    method: 'get',
    url: 'score/competency/detail'
  },
  // 删除胜任力模型列表数据
  scoreCompetencyItemDelete: {
    method: 'get',
    url: 'score/competency/item/delete'
  },
  // 关联胜任力
  scoreTableEditCompetency: {
    method: 'post',
    url: 'score/table/edit/competency'
  },
  //老师对学生评分记录
  examReportRecord: {
    method: 'get',
    url: 'exam/report/students/teacher/record'
  },
  //查询待考已考数据
  studentExamList: {
    method: 'get',
    url: 'student/exam/list'
  },
  //查询待考数据
  studentExamInfo: {
    method: 'get',
    url: 'student/exam/info'
  },
  //查询考试成绩
  studentExamReport: {
    method: 'get',
    url: 'student/exam/report'
  },
  // SP评卷列表
  examScorespList: {
    method: 'get',
    url: 'exam/score/sp/list'
  },
  //查询考试成绩
  studentExamJoinRoom: {
    method: 'get',
    url: 'student/exam/join/room'
  },
  //下载模板
  scoreTableDownloadTemplate: {
    method: 'get',
    url: 'score/table/download/template'
  },
  //导入评分表标准模板
  scoreTableImportStandard: {
    method: 'post',
    url: 'score/table/import/standard'
  },
  //导入评分表高级模板
  scoreTableImportHigh: {
    method: 'post',
    url: 'score/table/import/high'
  },
  //下载病例模板
  caseDownloadTemplate: {
    method: 'get',
    url: 'case/download/template'
  },
  // sp列表
  spCaseList: {
    method: 'get',
    url: 'sp/case/list'
  },
  // 考试信息
  examDetail: {
    method: 'get',
    url: 'exam/detail'
  },
  // 资源详情
  resPublicDetail: {
    method: 'get',
    url: 'res/public/detail'
  },
  // 资源列表
  resPublicList: {
    method: 'get',
    url: 'res/public/list'
  },
  // 资源新增
  resPublicEdit: {
    method: 'post',
    url: 'res/public/edit'
  },
  // 资源删除
  resPublicDelete: {
    method: 'get',
    url: 'res/public/delete'
  },
  //文件类型
  resPublicFormat: {
    method: 'get',
    url: 'res/public/format'
  },
  //目录查询
  resDirList: {
    method: 'get',
    url: 'res/dir/list'
  },
  //目录保存
  resDirEdit: {
    method: 'post',
    url: 'res/dir/edit'
  },
  //目录删除
  resDirDelete: {
    method: 'get',
    url: 'res/dir/delete'
  },
  //资源删除
  resPrivateDeletes: {
    method: 'post',
    url: 'res/private/deletes'
  },
  //资源删除
  resPrivateList: {
    method: 'get',
    url: 'res/private/list'
  },
  //资源保存
  resPrivateEdit: {
    method: 'post',
    url: 'res/private/edit'
  },
  //资源移动
  resPrivateMove: {
    method: 'post',
    url: 'res/private/move'
  },
  //回收站列表
  resRecycleList: {
    method: 'get',
    url: 'res/recycle/list'
  },
  //共享列表
  resShareTeacherList: {
    method: 'get',
    url: 'res/share/teacher/list'
  },
  //全部清空
  resRecycleClear: {
    method: 'post',
    url: 'res/recycle/clear'
  },
  //恢复
  resRecycleRestore: {
    method: 'post',
    url: 'res/recycle/restore'
  },
  //回收站删除
  resRecycleDelete: {
    method: 'post',
    url: 'res/recycle/delete'
  },
  //取消共享
  resShareCancel: {
    method: 'post',
    url: 'res/share/cancel'
  },
  //取消共享
  groupSubStudentList: {
    method: 'get',
    url: 'group/subStudentList'
  },
  //共享
  resShareSet: {
    method: 'post',
    url: 'res/share/set'
  },
  //共享
  resShareStudentList: {
    method: 'get',
    url: 'res/share/student/list'
  },
  // 查看其他老师是否已经切到了该学生
  examotherstudent: {
    method: 'get',
    url: 'exam/score/check/other/chang/student'
  },
  // 查看其他老师是否已经提交了该学生考试记录
  examothersubstudent: {
    method: 'get',
    url: 'exam/score/check/other/submit/score'
  },
  // 考试:复制
  examCopy: {
    method: 'get',
    url: 'exam/copy'
  },
  // 单位:禁止/解除禁止
  companyForbid: {
    method: 'get',
    url: 'company/forbid'
  },
  // 病例:公共病例列表
  casepubliclist: {
    method: 'get',
    url: 'case/public/list'
  },
  // 消息通知-列表
  msglistH5: {
    method: 'get',
    url: 'msg/list/h5'
  },
  // 消息通知-设置已读
  msgsetRead: {
    method: 'get',
    url: 'msg/set/read'
  },
  // 消息通知-设置一键全部已读
  msgsetReadAll: {
    method: 'get',
    url: 'msg/set/all/read'
  },
  // 设置当前用户状态
  userOnlineStatusSet: {
    method: 'get',
    url: 'user/onlineStatus/set'
  },
  // 学生训练报告
  trainstudent: {
    method: 'get',
    url: 'train/student/report'
  },
  // 学习资料：在线问诊
  publiconlinestudy: {
    method: 'get',
    url: 'res/public/online/study'
  },
  // 学习资料：在线问诊
  studentExamEvaluateSp: {
    method: 'post',
    url: 'student/exam/evaluate/sp'
  },
  // 角色列表
  roleList: {
    method: 'get',
    url: 'role/list'
  },
  // 角色新增
  roleEdit: {
    method: 'post',
    url: 'role/edit'
  },
  // 角色是否禁用
  roleSetStatus: {
    method: 'get',
    url: 'role/set/status'
  },
  // 角色删除
  roleDelete: {
    method: 'get',
    url: 'role/delete'
  },
  // 角色批量删除
  roleDeleteList: {
    method: 'post',
    url: 'role/deleteList'
  },
  // 角色详情
  roleDetail: {
    method: 'get',
    url: 'role/detail'
  },
  // 教师-设置学生缺考
  missingExam: {
    method: 'get',
    url: 'exam/missing/exam'
  },
  // 在线问诊：在线sp
  sponlineList: {
    method: 'get',
    url: 'sp/online/list'
  },
  // 学生创建一个训练，或者老师发起一个示教
  trainCreate: {
    method: 'post',
    url: 'train/create'
  },
  // 消息通知详情
  msgDetail: {
    method: 'get',
    url: 'msg/detail'
  },
  // SP提交学生训练 打分结果
  spstudentScore: {
    method: 'post',
    url: 'train/submit/student/score'
  },
  // 老师端：学生训练病例报告
  teacherreport: {
    method: 'get',
    url: 'train/teacher/report'
  },
  // 老师端：学生训练病例记录
  teacherrecord: {
    method: 'get',
    url: 'train/teacher/record'
  },
  // 日历设置:查看
  spweekdetail: {
    method: 'get',
    url: 'arrange/sp/week/detail'
  },
  // 日历设置:保存
  spweeksave: {
    method: 'post',
    url: 'arrange/sp/week/save'
  },
  // 预约列表
  sparrangelist: {
    method: 'get',
    url: 'online/consultation/sp/arrange/list'
  },
  // 历史记录
  onlinetrainlist: {
    method: 'get',
    url: 'online/consultation/sp/train/list'
  },
  // 日历设置：取消设置
  spweekcancel: {
    method: 'get',
    url: 'arrange/sp/week/cancel'
  },
  // 选择SP
  onlinechosesp: {
    method: 'post',
    url: 'online/consultation/chose/sp'
  },
  // 预约详情
  consultationdetail: {
    method: 'get',
    url: 'online/consultation/detail'
  },
  // 预约
  consultationarrangesp: {
    method: 'post',
    url: 'online/consultation/arrange/sp'
  },
  // 取消预约
  cancelarrangesp: {
    method: 'get',
    url: 'online/consultation/cancel/arrange'
  },
  // 我的预约
  myarrange: {
    method: 'get',
    url: 'online/consultation/my/arrange'
  },
  // 发送语音短信
  consultationsend: {
    method: 'get',
    url: 'voice/consultation/send'
  },
  // 单次在线问诊报告
  trainonereport: {
    method: 'get',
    url: 'train/one/report'
  },
  // 考试发布
  examPublish: {
    method: 'get',
    url: 'exam/publish'
  },
  // 单位预约列表
  arrangecompanylist: {
    method: 'post',
    url: 'arrange/company/list'
  },
  // 单位预约：编辑预约
  arrangecompanyedit: {
    method: 'post',
    url: 'arrange/company/edit'
  },
  // 单位预约：详情
  arrangecompanydetail: {
    method: 'get',
    url: 'arrange/company/detail'
  },
  // 单位预约：提交试用反馈
  submitfeedback: {
    method: 'get',
    url: 'arrange/company/submit/feedback'
  },
  // 单位预约：审批（通过，不通过，取消）
  companyapproval: {
    method: 'get',
    url: 'arrange/company/approval'
  },
  //  单位预约：删除
  arrangecompanydelete: {
    method: 'get',
    url: 'arrange/company/delete'
  },
  //  单位预约：批量通过/批量不通过
  arrangebatchapproval: {
    method: 'post',
    url: 'arrange/company/batch/approval'
  },
  //  学生群组查询
  companyTree: {
    method: 'get',
    url: 'company/tree'
  },
  //  访问量
  resPublicViewSet: {
    method: 'get',
    url: 'res/public/view/set'
  },
  // 评论：查询
  respubliccommentdetail: {
    method: 'get',
    url: 'res/public/comment/detail'
  },
  // 评论：提交
  respubliccommitadd: {
    method: 'get',
    url: 'res/public/comment/add'
  },
  // 点赞
  resPublicThumbsUp: {
    method: 'get',
    url: 'res/public/thumbsUp'
  },
  // 学生：训练记录列表
  trainStudentrecord: {
    method: 'get',
    url: 'train/student/record'
  },
  // 评分表类型
  scoreTableTypeList: {
    method: 'get',
    url: 'score/table/type/list'
  },
  // 训练项列表
  companionManageList: {
    method: 'get',
    url: 'companion/manage/list'
  },
  // 训练项禁用
  companionManageDisableSet: {
    method: 'get',
    url: 'companion/manage/disable/set'
  },
  // 训练项类型
  companionManageTypeList: {
    method: 'get',
    url: 'companion/manage/type/list'
  },
  // 评分表
  scoreTableCompanionList: {
    method: 'get',
    url: 'score/table/companion/list'
  },
  // 训练项保存
  companionManageEdit: {
    method: 'post',
    url: 'companion/manage/edit'
  },
  // 状态资源列表
  resPublicSimpleList: {
    method: 'get',
    url: 'res/public/simple/list'
  },
  // 训练详情
  companionManageDetail: {
    method: 'get',
    url: 'companion/manage/detail'
  },
  // 训练删除
  companionManageDeletes: {
    method: 'post',
    url: 'companion/manage/deletes'
  },
  // 训练详情
  companionDetail: {
    method: 'get',
    url: 'companion/detail'
  },
  // 统计分析：训练记录
  companionStatistic: {
    method: 'post',
    url: 'companion/statistic/record/list'
  },
  // 统计分析：按学生统计
  companionStudent: {
    method: 'post',
    url: 'companion/statistic/student/list'
  },
  // 统计分析：按训练项统计
  companionSte: {
    method: 'post',
    url: 'companion/statistic/ste/list'
  },
  // 统计分析：按班级统计
  companionClass: {
    method: 'post',
    url: 'companion/statistic/class/list'
  },
  // 训练项管理：列表（不分页）
  companionSimple: {
    method: 'get',
    url: 'companion/manage/simple/list'
  },
  // 任务列表
  codeList: {
    method: 'get',
    url: 'code/list'
  },
  // 任务：复制
  codeCopy: {
    method: 'get',
    url: 'code/copy'
  },
  // 任务：删除
  codeDelete: {
    method: 'get',
    url: 'code/delete'
  },
  // 任务类型列表
  codeTypeList: {
    method: 'get',
    url: 'code/type/list'
  },
  // 任务：编辑
  codeEdit: {
    method: 'post',
    url: 'code/edit'
  },
  // 任务：详情
  codeDetail: {
    method: 'get',
    url: 'code/detail'
  },
  // 学科:列表
  subjectList: {
    method: 'get',
    url: 'subject/list'
  },
  // 评分表：列表不分页
  scoreSimpleList: {
    method: 'get',
    url: 'score/table/simple/list'
  },
  // 病例:列表（不分页）
  casesimpleList: {
    method: 'get',
    url: 'case/simple/list'
  },
  // 评分表：列表（按类型返回）
  scoresimpleType: {
    method: 'get',
    url: 'score/table/simple/type'
  },
  //有病例学科列表）
  subjectcaselist: {
    method: 'get',
    url: 'subject/case/list'
  },
  //web-创建人-查看报告-学生列表）
  codeRecordList: {
    method: 'get',
    url: 'code/record/creator/student/list'
  },
  //web-创建人-查看报告-学生列表-打开报告
  coderecordreport: {
    method: 'get',
    url: 'code/record/creator/student/report'
  },
  //web-创建人-统计报告
  codecreatorReport: {
    method: 'get',
    url: 'code/record/creator/report'
  },
  //web-创建人-查看报告-学生列表-导出
  codeStudentexport: {
    method: 'get',
    url: 'code/record/creator/student/export'
  },
  // 评价模板列表
  evaluationList: {
    method: 'get',
    url: 'evaluation/list'
  },
  // 评价模板添加和修改
  evaluationEdit: {
    method: 'post',
    url: 'evaluation/edit'
  },
  //评价模板删除
  evaluationDelete: {
    method: 'get',
    url: 'evaluation/delete'
  },
  // 评价模板复制
  evaluationCopy: {
    method: 'get',
    url: 'evaluation/copy'
  },
  // 查看信息
  collectionList: {
    method: 'get',
    url: 'collection/list'
  },
  // 信息收集删除
  collectionDelete: {
    method: 'get',
    url: 'collection/delete'
  },
  //信息收集添加或修改
  collectionEdit: {
    method: 'post',
    url: 'collection/edit'
  },
  //评价模板详情
  evaluationDetail: {
    method: 'get',
    url: 'evaluation/detail'
  },
  // 科主任列表
  teacherListV2: {
    method: 'get',
    url: 'teacher/list/V2'
  },
  // 实施计划列表
  planList: {
    method: 'post',
    url: 'plan/list'
  },
  // 实施计划:删除（批量删除）
  planDeleteList: {
    method: 'post',
    url: 'plan/deleteList'
  },
  // 评价项目:列表
  evaluationProjectList: {
    method: 'get',
    url: 'evaluation/project/list'
  },
  // 实施计划:新增
  planInsert: {
    method: 'post',
    url: 'plan/edit'
  },
  // 老师详情
  teacherDetail: {
    method: 'get',
    url: 'teacher/detail'
  },
  // 实习人员查看
  planUserDetail: {
    method: 'post',
    url: 'planUser/student'
  },
  //实习人员删除
  planUserDeleteList: {
    method: 'post',
    url: 'planUser/deleteList'
  },
  //实习人员添加学生
  planUserAddstudent: {
    method: 'post',
    url: 'planUser/add/student'
  },
  //实施计划详情
  planDetail: {
    method: 'get',
    url: 'plan/detail'
  },
  //实施计划发布
  planPublish: {
    method: 'get',
    url: 'plan/publish'
  },
  //实习生轮转设置:列表
  planCycleList: {
    method: 'get',
    url: 'plan/cycle/list'
  },
  // 轮转详情日历
  calendarList: {
    method: 'get',
    url: 'planDetail/calendarList'
  },
  //实习生轮转设置:导入人员模板下载
  planCycleDownload: {
    method: 'get',
    url: 'plan/cycle/download/student'
  },
  // 实习生轮转设置:检索实习人员
  planCycleStudent: {
    method: 'post',
    url: 'plan/cycle/search/student'
  },
  //老师：检索
  teacherSearch: {
    method: 'get',
    url: 'teacher/search'
  },
  // 实习生轮转设置:添加实习人员
  planCycleUser: {
    method: 'post',
    url: 'plan/cycle/insert/user'
  },
  // 实习生轮转设置:查看
  planCycleDetail: {
    method: 'post',
    url: 'plan/cycle/detail'
  },
  // 轮转设置:查询已设置的带教老师
  planCycleteacher: {
    method: 'post',
    url: 'plan/cycle/default/teacher'
  },
  // 轮转详情:列表
  planDetailList: {
    method: 'post',
    url: 'planDetail/list'
  },
  // 轮转详情:列表
  planSearchStudent: {
    method: 'post',
    url: 'planDetail/search/student'
  },
  // 科室
  planDepartmentList: {
    method: 'get',
    url: 'planDetail/department/list'
  },
  // 轮转详情:删除
  planDeleteStudent: {
    method: 'post',
    url: 'planDetail/delete/student'
  },
  // 轮转详情:查询（编辑前调用）
  planDetailStudent: {
    method: 'post',
    url: 'planDetail/detail/student'
  },
  // 轮转详情:添加
  planInsertStudent: {
    method: 'post',
    url: 'planDetail/insert/student'
  },
  // 轮转详情:修改
  planEditStudent: {
    method: 'post',
    url: 'planDetail/edit/student'
  },
  // 导出
  planExport: {
    method: 'post',
    url: 'planDetail/export'
  },
  // 实习任务：列表
  planTasklist: {
    method: 'post',
    url: 'plan/task/list'
  },
  // 实习任务：部门列表
  planDepartTasklist: {
    method: 'get',
    url: 'plan/task/department/list'
  },
  // 带教老师
  planTaskTeacherlist: {
    method: 'get',
    url: 'plan/task/teacher/list'
  },
  //实施计划:评价项目列表
  plantaskprojectlist: {
    method: 'get',
    url: 'plan/task/project/list'
  },
  // 计划设置：查看
  planSetDetail: {
    method: 'get',
    url: 'plan/set/detail'
  },
  // 计划设置：保存
  planSetSave: {
    method: 'post',
    url: 'plan/set/save'
  },
  // 教师：评分详情
  plantaskteacherScore: {
    method: 'get',
    url: 'plan/task/teacher/score'
  },
  // 教师：提交评分
  evaSubmitstudentscore: {
    method: 'post',
    url: 'evaluation/submit/student/score'
  },
  // 评分：查看已评分
  evaStudentdepartmentscore: {
    method: 'get',
    url: 'evaluation/student/department/score'
  },
  // 轮转详情:附属科室-列表
  planDetailsubDepartmentList: {
    method: 'get',
    url: 'planDetail/subDepartment/list'
  },
  // 轮转详情：附属科室
  planprojectlist: {
    method: 'get',
    url: 'plan/project/list'
  },
  // 轮转设置:导入人员（上传文件）
  planimportfile: {
    method: 'post',
    url: 'plan/cycle/import/student/file'
  },
  // 首页显示TYPE
  HomeType: {
    method: 'get',
    url: 'homePage/subsidiary/type'
  },
  // 首页信息
  homePageHome: {
    method: 'get',
    url: 'homePage/home'
  },
  // 轮转学生
  homePageStudent: {
    method: 'post',
    url: 'homePage/subsidiary/student'
  },
  subsidiaryproject: {
    method: 'post',
    url: 'homePage/subsidiary/project'
  },
  usersignUpdate: {
    method: 'get',
    url: 'user/sign/update'
  },
  usersignDetail: {
    method: 'get',
    url: 'user/sign/detail'
  },
  // banner列表
  bannerList: {
    method: 'get',
    url: 'banner/list'
  },
  // banner列表
  bannerEdit: {
    method: 'post',
    url: 'banner/edit'
  },
  // banner删除
  bannerDelete: {
    method: 'get',
    url: 'banner/delete'
  },
  // banner发布
  bannerPublish: {
    method: 'post',
    url: 'banner/publish'
  },
  // 微信登录（web网站应用）
  loginweChatWeb: {
    method: 'get',
    url: 'auth/login/weChat/web'
  },
  // 绑定微信（web网站应用）
  wechatwebBinding: {
    method: 'get',
    url: 'wechat/web/binding'
  },
  // 教职工角色下拉框列表
  roleFacultyLlist: {
    method: 'get',
    url: 'role/faculty/list'
  },
  // 消息通知-是否已完成
  msgIsover: {
    method: 'get',
    url: 'msg/isover'
  },
  // 公共资源管理列表
  resmanageList: {
    method: 'get',
    url: 'res/public/manage/list'
  },
  // 解除微信绑定
  weChatUnbinding: {
    method: 'get',
    url: 'user/weChat/unbinding'
  },
  // 解除微信绑定
  spTimeList: {
    method: 'get',
    url: 'arrange/sp/timeList'
  },
  // sp擅长病例列表
  spGoodCaselist: {
    method: 'get',
    url: 'sp/good/case/list'
  },
  // 给出预约时间
  consultationtime: {
    method: 'post',
    url: 'online/consultation/arrange/time'
  },
  // SP培训计划列表
  sptrainplanlist: {
    method: 'get',
    url: 'sp/train/plan/list'
  },
  // SP培训计划编辑
  sptrainplanedit: {
    method: 'post',
    url: 'sp/train/plan/edit'
  },
  // SP招募列表
  sprecruitnoticelist: {
    method: 'get',
    url: 'sp/recruit/notice/list'
  },
  // SP师资培训通知列表
  spteachertrainlist: {
    method: 'get',
    url: 'sp/teacher/train/list'
  },
  // SP报名-列表-查询条件-培训计划列表
  sptrainplanpublishedlist: {
    method: 'get',
    url: 'sp/train/plan/published/list'
  },
  // SP报名列表
  sptrainsplist: {
    method: 'get',
    url: 'sp/train/sp/list'
  },
  // 报名模板下载
  sptraindownloadtemplate: {
    method: 'get',
    url: 'sp/train/sp/download/template'
  },
  // 报名导入
  spimportfile: {
    method: 'post',
    url: 'sp/train/sp/import/sp/file'
  },
  // 富文本上传
  fileuploadv2: {
    method: 'post',
    url: 'file/upload/v2'
  },
  // 督导列表名称
  supervisenamelist: {
    method: 'get',
    url: 'supervise/exam/name/list'
  },
  // 督导列表
  superviseexamlist: {
    method: 'get',
    url: 'supervise/exam/list'
  },
  // 播间正在直播人员
  superviseexaminRoom: {
    method: 'get',
    url: 'supervise/exam/inRoom'
  },
  // 问诊督导列表
  superviseonlinelist: {
    method: 'get',
    url: 'supervise/online/list'
  },
  // 有SP地区
  regionhavesplist: {
    method: 'get',
    url: 'region/have/sp/list'
  },
  // 房间列表
  offlinehouselist: {
    method: 'get',
    url: 'offline/house/list'
  },
  // 房间编辑
  offlinehouseedit: {
    method: 'post',
    url: 'offline/house/edit'
  },
  // 房间删除
  offlinehousedelete: {
    method: 'get',
    url: 'offline/house/delete'
  },
  // 线下考试列表
  offlineexamList: {
    method: 'get',
    url: 'offline/exam/list'
  },
  // 线下考试删除
  offlineexamdelete: {
    method: 'get',
    url: 'offline/exam/delete'
  },
  // 线下考试编辑
  offlineexamedit: {
    method: 'post',
    url: 'offline/exam/edit'
  },
  // 排考学生列表
  offlineexamstudentlist: {
    method: 'get',
    url: 'offline/exam/student/list'
  },
  // 排考学生列表
  offlineexamupdatestudent: {
    method: 'post',
    url: 'offline/exam/update/student'
  },
  // 已排考学生：导出
  offlineexamstudentexport: {
    method: 'get',
    url: 'offline/exam/student/export'
  },
  // 病例的评分表列表
  casescorelist: {
    method: 'get',
    url: 'case/score/list'
  },
  // 考站SP列表
  offlineexamsplist: {
    method: 'get',
    url: 'offline/exam/sp/list'
  },
  // 考站编辑
  offlineexamstationedit: {
    method: 'post',
    url: 'offline/exam/station/edit'
  },
  // 考站列表
  offlineexamstationsnlist: {
    method: 'get',
    url: 'offline/exam/station/sn/list'
  },
  // 统计分析-统计
  scoredbusinessstatistics: {
    method: 'get',
    url: 'scored/business/statistics'
  },
  // 统计分析-统计
  scoredtotalscorelist: {
    method: 'get',
    url: 'scored/total/score/list'
  },
  // 统计分析-成绩导出
  scoredtotalscoreexport: {
    method: 'get',
    url: 'scored/total/score/export'
  },
  // 统计分析-成绩导出
  scoredofflineanalysislist: {
    method: 'get',
    url: 'scored/offline/analysis/list'
  },
  // 查看报告
  offlineexamstudentscorelist: {
    method: 'get',
    url: 'offline/exam/student/score/list'
  },
  // 查看报告
  scoredonescorelist: {
    method: 'post',
    url: 'scored/one/score/list'
  },
  // top10考站分析-典型错误
  scoredstationitemtop10list: {
    method: 'get',
    url: 'scored/station/item/top10/list'
  },
  // 考站分析-操作错误详情
  scoredstationsteitemlist: {
    method: 'get',
    url: 'scored/station/ste/item/list'
  },
  // 考站分析-成绩详情-导出
  scoredofflineanalysisexport: {
    method: 'get',
    url: 'scored/offline/analysis/export'
  },
  // 考站分析-根据考站id查询评分表列表
  offlineexamstationstelist: {
    method: 'get',
    url: 'offline/exam/station/ste/list'
  },
  // 考站分析-根据考站id查询评分表列表
  userapplist: {
    method: 'get',
    url: 'user/app/list'
  },
  // 线下考试复制
  offlineexamcopy: {
    method: 'get',
    url: 'offline/exam/copy'
  },
  // 修改状态
  spchangestatus: {
    method: 'get',
    url: 'sp/change/status'
  },
  // 删除文件
  filedelete: {
    method: 'get',
    url: 'file/delete'
  },
  // 报名人员列表
  sprecruitnoticesplist: {
    method: 'get',
    url: 'sp/recruit/notice/sp/list'
  },
  // 报名审核
  sprecruitnoticeapprove: {
    method: 'post',
    url: 'sp/recruit/notice/approve'
  },
  // sp详情
  spdetail: {
    method: 'get',
    url: 'sp/detail'
  },
  // 评分表：列表不分页（本单位外单位）
  scoretablesimplealllist: {
    method: 'get',
    url: 'score/table/simple/all/list'
  },
  // 楼栋列表
  buildingsmanageGetbuilding: {
    method: 'get',
    url: 'buildingsmanage/getbuilding'
  },
  // 楼栋新增
  buildingsmanageaddbuilding: {
    method: 'post',
    url: 'buildingsmanage/addbuilding'
  },
  // 楼栋编辑
  buildingsmanageupdatebuilding: {
    method: 'post',
    url: 'buildingsmanage/updatebuilding'
  },
  // 楼栋删除
  buildingsmanagedelbuilding: {
    method: 'get',
    url: 'buildingsmanage/delbuilding'
  },
  // 类别列表
  sitelistplacecate: {
    method: 'get',
    url: 'site/listplacecate'
  },
  // 楼栋列表
  hrquerylevellist: {
    method: 'get',
    url: 'hr/querylevellist'
  },
  // 场地维护列表
  sitelistplace: {
    method: 'get',
    url: 'site/listplace'
  },
  // 教职工列表（不分页）
  teachersimplelist: {
    method: 'get',
    url: 'teacher/simple/list'
  },
  // 新增-场地编码-生成
  sitegeneratecdcode: {
    method: 'get',
    url: 'site/generatecdcode'
  },
  // 场地新增
  siteaddplace: {
    method: 'post',
    url: 'site/addplace'
  },
  // 场地查看
  sitefindplace: {
    method: 'get',
    url: 'site/findplace'
  },
  // 场地更新
  siteupdateplace: {
    method: 'post',
    url: 'site/updateplace'
  },
  // 删除管理员
  siteupdateplaceadmin: {
    method: 'get',
    url: 'site/updateplaceadmin'
  },
  // 删除场地
  sitedeleteplace: {
    method: 'get',
    url: 'site/deleteplace'
  },
  // 物品分类列表
  assetcategetallassetcates: {
    method: 'get',
    url: 'assetcate/getallassetcates'
  },
  // 物品分类新增
  assetcateaddassetcatenew: {
    method: 'post',
    url: 'assetcate/addassetcatenew'
  },
  // 物品分类更新
  assetcateupdateassetcate: {
    method: 'post',
    url: 'assetcate/updateassetcate'
  },
  // 物品分类删除
  assetcatedeleteassetcate: {
    method: 'post',
    url: 'assetcate/deleteassetcate'
  },
  // 楼栋楼层房间列表
  sitegetbuildfloor: {
    method: 'get',
    url: 'site/getbuildfloor'
  },
  // 列表（固定资产和易耗品）
  assetcategetallassetcatesnew: {
    method: 'get',
    url: 'assetcate/getallassetcatesnew'
  },
  // 物品管理列表（固定资产和易耗品）
  assetsmanagequeryallassets2: {
    method: 'get',
    url: 'assetsmanage/queryallassets2'
  },
  // 物品管理新增
  assetsmanageaddassets2: {
    method: 'post',
    url: 'assetsmanage/addassets2'
  },
  // 批量设置
  assetsmanageupdateassetlist: {
    method: 'post',
    url: 'assetsmanage/updateassetlist'
  },
  // 查看资产
  assetsmanagegetassetinfo2: {
    method: 'get',
    url: 'assetsmanage/getassetinfo2'
  },
  // 更新资产
  assetsmanageupdateasset2: {
    method: 'post',
    url: 'assetsmanage/updateasset2'
  },
  // 删除资产
  assetsmanagedeleteasset2: {
    method: 'get',
    url: 'assetsmanage/deleteasset2'
  },
  // 下载模板
  exportexportExcelMould: {
    method: 'get',
    url: 'export/exportExcelMould'
  },
  // 导入
  assetsmanageimportassetinfo: {
    method: 'post',
    url: 'assetsmanage/importassetinfo'
  },
  // 批量下载二维码
  assetsmanagedownload4qrcodebat: {
    method: 'post',
    url: 'assetsmanage/download4qrcodebat'
  },
  // 计量单位管理列表
  assetunitqueryunitlist: {
    method: 'get',
    url: 'assetunit/queryunitlist'
  },
  // 库存信息-库存详情
  assetstoragemanagequeryassetdetail: {
    method: 'post',
    url: 'assetstoragemanage/queryassetdetail'
  },
  // 入库/出库-单据编号生成
  assetstoragemanagequerynextdocumentnum: {
    method: 'get',
    url: 'assetstoragemanage/querynextdocumentnum'
  },
  // 场地查询
  sitelistplacebycate: {
    method: 'get',
    url: 'site/listplacebycate'
  },
  // 入库保存
  assetstoragemanageinassetstorage: {
    method: 'post',
    url: 'assetstoragemanage/inassetstorage'
  },
  // 入库/出库-历史单据查询
  assetstoragemanageassetstoragedochistory: {
    method: 'get',
    url: 'assetstoragemanage/assetstoragedochistory'
  },
  // 入库-库存详情
  assetstoragemanageinassetstoragedetail: {
    method: 'get',
    url: 'assetstoragemanage/inassetstoragedetail'
  },
  // 出库-保存
  assetstoragemanageoutassetstorage: {
    method: 'post',
    url: 'assetstoragemanage/outassetstorage'
  },
  // 出库-详情
  assetstoragemanageoutassetstoragedetail: {
    method: 'get',
    url: 'assetstoragemanage/outassetstoragedetail'
  },
  // 计量单位新增
  assetunitaddunit: {
    method: 'get',
    url: 'assetunit/addunit'
  },
  // 计量单位更新
  ssetunitupdateunit: {
    method: 'get',
    url: 'assetunit/updateunit'
  },
  // 计量单位删除
  assetunitdeleteunit: {
    method: 'get',
    url: 'assetunit/deleteunit'
  },
  // 物品使用审核列表
  adminqueryrecord: {
    method: 'get',
    url: 'assetLendObtain/admin/queryrecord'
  },
  // 物品审批详情
  admingetapprovalinfo: {
    method: 'get',
    url: 'assetLendObtain/admin/getapprovalinfo'
  },
  // 物品审批详情
  adminpushapprovalinfo: {
    method: 'get',
    url: 'assetLendObtain/admin/pushapprovalinfo'
  },
  // 物品使用状态
  queryAssetApprovalStatus: {
    method: 'get',
    url: 'assetLendObtain/admin/queryAssetApprovalStatus'
  },
  // 物品使用状态导出
  queryAssetApprovalStatusexport: {
    method: 'get',
    url: 'assetLendObtain/admin/queryAssetApprovalStatus/export'
  },
  // 按场地查询列表
  learnqueryplaceopeninfo: {
    method: 'get',
    url: 'learn/queryplaceopeninfo'
  },
  // 新增-选择开放教室
  sitesitelist2: {
    method: 'get',
    url: 'site/sitelist2'
  },
  // 查询实验室使用（本单位所有的）
  learnxwlabusage: {
    method: 'get',
    url: 'learnxw/labusage2'
  },
  // 列表（场地管理员）
  appointmentbatchapproveinfolist: {
    method: 'post',
    url: 'appointment/batchapproveinfolist'
  },
  // 通过/不通过
  learnbatchapprove: {
    method: 'post',
    url: 'learn/batchapprove'
  },
  //预约详情
  appointmentbatchapprovedetail: {
    method: 'post',
    url: 'appointment/batchapprovedetail'
  },
  //取消审核
  learnupdatestudentapplystatus: {
    method: 'get',
    url: 'learn/updatestudentapplystatus'
  },
  //取消审核
  learnupdatestudentapplystatus: {
    method: 'get',
    url: 'learn/updatestudentapplystatus'
  },
  // 预约查询列表（本单位所有的）
  appointmentrecordsgetappointmentrecords: {
    method: 'post',
    url: 'appointmentrecords/getappointmentrecords'
  },
  // 运营管理系统设置
  systemquerysetlist: {
    method: 'get',
    url: 'system/querysetlist'
  },
  // 开放范围-列表
  learnqueryopenuserlist: {
    method: 'get',
    url: 'learn/queryopenuserlist'
  },
  // 开放范围-教师-部门
  departmentfindTeacherReceiverInfo: {
    method: 'get',
    url: 'department/findTeacherReceiverInfo'
  },
  // 开放范围-学生-部门
  studentfindStudentReceiverInfo: {
    method: 'get',
    url: 'student/findStudentReceiverInfo'
  },
  // 开放范围-根据姓名或手机号查询用户
  userqueryUserByNameOrTel: {
    method: 'get',
    url: 'user/queryUserByNameOrTel'
  },
  // 开放范围-查询用户层级结构，属于那个部门或那个年级班级或上课班级
  userqueryOpenParentInfo: {
    method: 'get',
    url: 'user/queryOpenParentInfo'
  },
  // 开放范围-保存
  learnsaveopenrange: {
    method: 'post',
    url: 'learn/saveopenrange'
  },
  // 开放范围-删除/批量删除
  learndelopenuser: {
    method: 'post',
    url: 'learn/delopenuser'
  },
  // 修改-开放用途-取消其他
  learndelallopenrange: {
    method: 'get',
    url: 'learn/delallopenrange'
  },
  // 新增-训练项列表
  learnquerylearninfo: {
    method: 'get',
    url: 'learn/querylearninfo'
  },
  // 开发时间段范围查询
  commparaconfquerycommparaconflist: {
    method: 'get',
    url: 'commparaconf/querycommparaconflist'
  },
  // 上课时间
  examapplyqueryexamtimeslist: {
    method: 'get',
    url: 'examapply/queryexamtimeslist'
  },
  // 保存-更新
  learnnewupdateplaceandopentime: {
    method: 'post',
    url: 'learnnew/updateplaceandopentime'
  },
  // 保存-新增
  learnnewaddplaceandopentime: {
    method: 'get',
    url: 'learnnew/addplaceandopentime'
  },
  // 修改训练位-查询
  learnlistplaceworkstation: {
    method: 'get',
    url: 'learn/listplaceworkstation'
  },
  // 修改开放时间-查询
  learnnewlistplaceopentime: {
    method: 'get',
    url: 'learnnew/listplaceopentime'
  },
  // 删除
  learnnewdelopenplace: {
    method: 'get',
    url: 'learnnew/delopenplace'
  },
  // 按训练项查询列表
  learnquerylearnopeninfo: {
    method: 'get',
    url: 'learn/querylearnopeninfo'
  },
  // 按训练项查询-开放详情
  learnlistlearnopendetail: {
    method: 'get',
    url: 'learn/listlearnopendetail'
  },
  // 按训练项查询-开放详情
  learnupdatelearntimes: {
    method: 'get',
    url: 'learn/updatelearntimes'
  },
  // 场地使用率列表
  siteusequerysiteuserecord: {
    method: 'get',
    url: 'siteuse/querysiteuserecord'
  },
  // 报告列表
  plantaskmanagerlist: {
    method: 'get',
    url: 'plan/task/manager/list'
  },
  // 科室列表
  departmentqueryDeptOfUser: {
    method: 'get',
    url: 'department/queryDeptOfUser'
  },
  // 场地使用率-使用详情
  siteusequerysiteusedetail: {
    method: 'get',
    url: 'siteuse/querysiteusedetail'
  },
  // 场地使用率-周日历-场地列表
  sitesitelist: {
    method: 'get',
    url: 'site/sitelist'
  },
  // 场地使用率-周日历
  siteusequerysiteweeklycalendar: {
    method: 'get',
    url: 'siteuse/querysiteweeklycalendar'
  },
  // 修改/禁用
  coursev2modify: {
    method: 'post',
    url: 'coursev2/modify'
  },
  // 新增
  coursev2add: {
    method: 'post',
    url: 'coursev2/add'
  },
  // 列表
  coursev2querypage: {
    method: 'post',
    url: 'coursev2/querypage'
  },
  // 列表
  coursev2batchRemove: {
    method: 'post',
    url: 'coursev2/batchRemove'
  },
  // 关联教师-已关联教师列表
  coursev2querycoursesteacher: {
    method: 'post',
    url: 'coursev2/querycoursesteacher'
  },
  // 关联教师-已关联教师列表
  coursev2queryteachers: {
    method: 'get',
    url: 'coursev2/queryteachers'
  },
  // 关联教师-添加
  coursev2addcoursesteacher: {
    method: 'post',
    url: 'coursev2/addcoursesteacher'
  },
  // 关联教师-删除/批量删除
  coursev2removecoursesteacher: {
    method: 'post',
    url: 'coursev2/removecoursesteacher'
  },
  // 关联训练项-已关联训练项列表
  coursev2querycourseslearn: {
    method: 'post',
    url: 'coursev2/querycourseslearn'
  },
  // 关联训练项-删除/批量删除
  coursev2removecourseslearn: {
    method: 'post',
    url: 'coursev2/removecourseslearn'
  },
  // 关联训练项-添加
  coursev2addcourseslearn: {
    method: 'post',
    url: 'coursev2/addcourseslearn'
  },
  // 课程内容-列表
  coursev2querycoursescontentlist: {
    method: 'get',
    url: 'coursev2/querycoursescontentlist'
  },
  // 课程内容-添加
  coursev2addcoursescontent: {
    method: 'post',
    url: 'coursev2/addcoursescontent'
  },
  // 课程内容-删除
  coursev2removecoursescontent: {
    method: 'post',
    url: 'coursev2/removecoursescontent'
  },
  // 课程内容-修改
  coursev2modifycoursescontent: {
    method: 'post',
    url: 'coursev2/modifycoursescontent'
  },
  // 课程内容-修改
  sysgradeall: {
    method: 'get',
    url: 'sys/grade/all'
  },
  // 学期新增
  semestersavesesemterinfo: {
    method: 'post',
    url: 'semester/savesesemterinfo'
  },
  // 学期列表
  semesterlistsesemterinfo: {
    method: 'get',
    url: 'semester/listsesemterinfo'
  },
  // 学期修改
  semesterupdatesesemterinfo: {
    method: 'post',
    url: 'semester/updatesesemterinfo'
  },
  // 年份新增
  sysgradeadd: {
    method: 'get',
    url: 'sys/grade/add'
  },
  // 学期批量删除
  semesterbatchremove: {
    method: 'post',
    url: 'semester/batchremove'
  },
  // 学期删除
  semesterbatchremove: {
    method: 'post',
    url: 'semester/batchremove'
  },
  // 学期删除
  semesterremovesesemterinfo: {
    method: 'get',
    url: 'semester/removesesemterinfo'
  },
  // 关联wifi:列表
  sitewifilist: {
    method: 'get',
    url: 'site/wifi/list'
  },
  // 关联wifi:新增
  sitewifiadd: {
    method: 'get',
    url: 'site/wifi/add'
  },
  // 关联wifi:修改
  sitewifiupdate: {
    method: 'get',
    url: 'site/wifi/update'
  },
  // 关联wifi:删除
  sitewifidelete: {
    method: 'get',
    url: 'site/wifi/delete'
  },
  // 学生-训练项统计-查看成长记录
  companionstatisticstegrowthRecordlist: {
    method: 'get',
    url: 'companion/statistic/ste/growthRecord/list'
  },
  // 学生-典型错误top10-训练项列表
  companionstatisticstudenttop10companion: {
    method: 'get',
    url: 'companion/statistic/student/top10/companion'
  },
  // 学生-典型错误top10
  companionstatisticstudenttop10: {
    method: 'get',
    url: 'companion/statistic/student/top10'
  },
  // 统计分析-按训练项统计-学生成绩排名前10
  companionstatisticstestudentScoretop10list: {
    method: 'get',
    url: 'companion/statistic/ste/studentScore/top10/list'
  },
  // 统计分析-按训练项统计-成绩统计
  companionstatisticstudentScorestatistics: {
    method: 'get',
    url: 'companion/statistic/studentScore/statistics'
  },
  // 统计分析-按训练项统计-典型错误top10/操作错误详情
  companionstatisticstetop10list: {
    method: 'get',
    url: 'companion/statistic/ste/top10/list'
  },
  // 统计分析-按班级统计-学生成绩排名-训练项列表
  companionstatisticclassstudentScorecompanionlist: {
    method: 'get',
    url: 'companion/statistic/class/studentScore/companion/list'
  },
  // 统计分析-按班级统计-学生成绩排名
  companionstatisticclassstudentScorelist: {
    method: 'get',
    url: 'companion/statistic/class/studentScore/list'
  },
  // 列表
  planteacherlist: {
    method: 'get',
    url: 'plan/teacher/list'
  },
  // 未评价人员列表
  planteachernoScorelist: {
    method: 'get',
    url: 'plan/teacher/noScore/list'
  },
  // 未评价人员导出
  planteachernoScoreexport: {
    method: 'get',
    url: 'plan/teacher/noScore/export'
  },
  // 带教学生记录
  plantaskmanagerteacherlist: {
    method: 'get',
    url: 'plan/task/manager/teacher/list'
  },
  // 考区列表
  osceareaQueryareainfo: {
    method: 'get',
    url: 'oscearea/queryareainfo'
  },
  // 考区新增
  osceareaaddarea: {
    method: 'get',
    url: 'oscearea/addarea'
  },
  // 考区编辑
  osceareaupdatearea: {
    method: 'get',
    url: 'oscearea/updatearea'
  },
  // 考区删除
  osceareadelarea: {
    method: 'get',
    url: 'oscearea/delarea'
  },
  // 考试项目列表
  oscestationListoscestation: {
    method: 'get',
    url: 'oscestation/listoscestation'
  },
  // 考试项目新增
  oscestationinsertoscestation: {
    method: 'post',
    url: 'oscestation/insertoscestation'
  },
  // 考试项目编辑
  oscestationupdateoscestation: {
    method: 'post',
    url: 'oscestation/updateoscestation'
  },
  // 考试项目删除
  oscestationdeleteoscestation: {
    method: 'get',
    url: 'oscestation/deleteoscestation'
  },
  // 设备列表
  oscemanagedevicelistoscemanagedevice: {
    method: 'post',
    url: 'oscemanagedevice/listoscemanagedevice'
  },
  // 设备类型
  commparaconfquerycommparaconflist: {
    method: 'get',
    url: 'commparaconf/querycommparaconflist'
  },
  // 设备类型新增
  oscemanagedeviceinsertoscemanagedevice: {
    method: 'post',
    url: 'oscemanagedevice/insertoscemanagedevice'
  },
  // 设备类型编辑
  oscemanagedeviceupdateoscemanagedevice: {
    method: 'post',
    url: 'oscemanagedevice/updateoscemanagedevice'
  },
  // 设备删除
  oscemanagedevicedeleteoscemanagedevice: {
    method: 'post',
    url: 'oscemanagedevice/deleteoscemanagedevice'
  },
  // 考试场所列表
  oscemanageroomlistoscemanageroom: {
    method: 'post',
    url: 'oscemanageroom/listoscemanageroom'
  },
  // 考区列表
  oscemanageareaqueryareainfo: {
    method: 'get',
    url: 'oscemanagearea/queryareainfo'
  },
  // 考区新增
  oscemanageareaaddarea: {
    method: 'get',
    url: 'oscemanagearea/addarea'
  },
  // 考区编辑
  oscemanageareaupdatearea: {
    method: 'get',
    url: 'oscemanagearea/updatearea'
  },
  // 考区删除
  oscemanageareadelarea: {
    method: 'get',
    url: 'oscemanagearea/delarea'
  },
  // 考试场所管理新增
  oscemanageroominsertoscemanageroom: {
    method: 'post',
    url: 'oscemanageroom/insertoscemanageroom'
  },
  // 考试场所管理删除
  oscemanageroomdeleteoscemanageroom: {
    method: 'post',
    url: 'oscemanageroom/deleteoscemanageroom'
  },
  // 考试场所管理编辑
  oscemanageroomupdateoscemanageroom: {
    method: 'post',
    url: 'oscemanageroom/updateoscemanageroom'
  },
  // 标签列表
  labquerylabinfolist: {
    method: 'get',
    url: 'lab/querylabinfolist'
  },
  // 标签删除
  labdeletelabinfo: {
    method: 'get',
    url: 'lab/deletelabinfo'
  },
  // 标签新增
  labaddlabinfo: {
    method: 'get',
    url: 'lab/addlabinfo'
  },
  // 题目类别管理列表
  questionquestioncategorytree: {
    method: 'get',
    url: 'question/questioncategorytree'
  },
  // 题目类别管理新增
  questioninsertquestioncategory: {
    method: 'get',
    url: 'question/insertquestioncategory'
  },
  // 题目类别管理编辑
  questionupdatequestioncategory: {
    method: 'get',
    url: 'question/updatequestioncategory'
  },
  // 题目类别管理删除
  questiondeletequestioncategory: {
    method: 'get',
    url: 'question/deletequestioncategory'
  },
  // 题目列表
  questionqueryquestionlist: {
    method: 'get',
    url: 'question/queryquestionlist'
  },
  // 题目标签
  questionquerylablist: {
    method: 'get',
    url: 'question/querylablist'
  },
  // 详情（单选、多选、判断、问答、填空）
  questionquerysinglequestion: {
    method: 'get',
    url: 'question/querysinglequestion'
  },
  // 详情（单选、多选、判断、问答、填空）
  labaddlabinfo: {
    method: 'get',
    url: 'lab/addlabinfo'
  },
  // 新增（单选、多选、判断、问答、填空）
  questionaddquestioninf: {
    method: 'post',
    url: 'question/addquestioninfo'
  },
  // 编辑（单选、多选、判断、问答、填空）
  questionupdatetheoryquestioninfo: {
    method: 'post',
    url: 'question/updatetheoryquestioninfo'
  },
  // 删除
  questiondeletequestion: {
    method: 'get',
    url: 'question/deletequestion'
  },
  // 导入
  questionimporttheoreticalquestions: {
    method: 'post',
    url: 'question/importtheoreticalquestions'
  },
  // 新增（操作题）
  questioninsertoperationquestionsa: {
    method: 'post',
    url: 'question/insertoperationquestion/sa'
  },
  // 详情（操作题）
  questionqueryoprquestion: {
    method: 'get',
    url: 'question/queryoprquestion'
  },
  // 编辑（操作题）
  questionupdateoperationquestionsa: {
    method: 'post',
    url: 'question/updateoperationquestion/sa'
  },
  // 启用/禁用TRTC录制
  companytrtc: {
    method: 'get',
    url: 'company/trtc'
  },
  // 单位详情
  companydetail: {
    method: 'get',
    url: 'company/detail'
  },
  // 详情（组合题）
  questionquerycombinationquestion: {
    method: 'get',
    url: 'question/querycombinationquestion'
  },
  // 新增（组合题）
  questionaddassociationquestion: {
    method: 'post',
    url: 'question/addassociationquestion'
  },
  // 編輯（组合题）
  questionupdateassociationquestioninfo: {
    method: 'post',
    url: 'question/updateassociationquestioninfo'
  },
  // 分享
  questioninsertShareQuestionCategory: {
    method: 'post',
    url: 'question/insertShareQuestionCategory'
  },
  // 试卷列表
  exampaperquerypaper: {
    method: 'post',
    url: 'exampaper/querypaper'
  },
  // 预约信息确认-选择课程
  coursev2querycoursesbyteacherid: {
    method: 'get',
    url: 'coursev2/querycoursesbyteacherid'
  },
  // 新增试卷
  exampaperaddpaper: {
    method: 'get',
    url: 'exampaper/addpaper'
  },
  // 刪除试卷
  exampaperdeletepaper: {
    method: 'get',
    url: 'exampaper/deletepaper'
  },
  // 选择题目-已选
  exampaperqueryselectedquestion: {
    method: 'get',
    url: 'exampaper/queryselectedquestion'
  },
  // sp评价列表
  spremarklist: {
    method: 'get',
    url: 'sp/remark/list'
  },
  // sp评价详情
  spremarklabelcompetency: {
    method: 'get',
    url: 'sp/remark/label/competency'
  },
  // sp评价详情列表
  spremarkstudentlist: {
    method: 'get',
    url: 'sp/remark/student/list'
  },
  // 超级管理、单位管理员查看SP使用统计
  spusedrecordlistOfManager: {
    method: 'get',
    url: 'sp/used/record/listOfManager'
  },
  // 超级管理、单位管理员查看SP使用记录
  spusedrecordRecordOfSpAndCpyManager: {
    method: 'get',
    url: 'sp/used/record/RecordOfSpAndCpy/Manager'
  },
  // SP个人查看自己的使用统计记录
  spusedrecordlistOfSp: {
    method: 'get',
    url: 'sp/used/record/listOfSp'
  },
  // SP个人查看自己的单位使用记录
  spusedrecordRecordOfSpAndCpy: {
    method: 'get',
    url: 'sp/used/record/RecordOfSpAndCpy'
  },
  // 新增（组合题）
  questionaddassociationquestion: {
    method: 'post',
    url: 'question/addassociationquestion'
  },
  // 編輯（组合题）
  questionupdateassociationquestioninfo: {
    method: 'post',
    url: 'question/updateassociationquestioninfo'
  },
  // 分享
  questioninsertShareQuestionCategory: {
    method: 'post',
    url: 'question/insertShareQuestionCategory'
  },
  // 试卷列表
  exampaperquerypaper: {
    method: 'post',
    url: 'exampaper/querypaper'
  },
  // 预约信息确认-选择课程
  coursev2querycoursesbyteacherid: {
    method: 'get',
    url: 'coursev2/querycoursesbyteacherid'
  },
  // 新增试卷
  exampaperaddpaper: {
    method: 'get',
    url: 'exampaper/addpaper'
  },
  // 刪除试卷
  exampaperdeletepaper: {
    method: 'get',
    url: 'exampaper/deletepaper'
  },
  // 选择题目-已选
  exampaperqueryselectedquestion: {
    method: 'get',
    url: 'exampaper/queryselectedquestion'
  },
  // sp评价列表
  spremarklist: {
    method: 'get',
    url: 'sp/remark/list'
  },
  // sp评价详情
  spremarklabelcompetency: {
    method: 'get',
    url: 'sp/remark/label/competency'
  },
  // sp评价详情列表
  spremarkstudentlist: {
    method: 'get',
    url: 'sp/remark/student/list'
  },
  // 超级管理、单位管理员查看SP使用统计
  spusedrecordlistOfManager: {
    method: 'get',
    url: 'sp/used/record/listOfManager'
  },
  // 超级管理、单位管理员查看SP使用记录
  spusedrecordRecordOfSpAndCpyManager: {
    method: 'get',
    url: 'sp/used/record/RecordOfSpAndCpy/Manager'
  },
  // SP个人查看自己的使用统计记录
  spusedrecordlistOfSp: {
    method: 'get',
    url: 'sp/used/record/listOfSp'
  },
  // SP个人查看自己的单位使用记录
  spusedrecordRecordOfSpAndCpy: {
    method: 'get',
    url: 'sp/used/record/RecordOfSpAndCpy'
  },
  // 选择题目-加入试卷
  exampaperjoinpaperquestion: {
    method: 'post',
    url: 'exampaper/joinpaperquestion'
  },
  // 选择题目-取消加入试卷
  exampapercancelpaperquestion: {
    method: 'post',
    url: 'exampaper/cancelpaperquestion'
  },
  // 选择题目-加入试卷
  exampaperjoinpaperquestion2: {
    method: 'post',
    url: 'exampaper/joinpaperquestion2'
  },
  // 选择题目-取消加入试卷
  exampapercancelpaperquestion2: {
    method: 'post',
    url: 'exampaper/cancelpaperquestion2'
  },
  // 非操作题-编辑试卷-试卷
  exampaperviewpaper: {
    method: 'get',
    url: 'exampaper/viewpaper'
  },
  // 非理论题-编辑试卷-题目类型
  exampaperquerypapercategorylist: {
    method: 'get',
    url: 'exampaper/querypapercategorylist'
  },
  // 非操作题-编辑试卷-类型题目
  exampaperquerypaperquestion: {
    method: 'get',
    url: 'exampaper/querypaperquestion'
  },
  // 非操作题-保存
  exampaperupdatepaper: {
    method: 'post',
    url: 'exampaper/updatepaper'
  },
  // 操作题-保存
  exampaperoperatquestionscore: {
    method: 'post',
    url: 'exampaper/operatquestionscore'
  },
  // 考试列表
  oscenewexamquery2examlist: {
    method: 'get',
    url: 'oscenewexamquery2/examlist'
  },
  // 考试列表基础保存
  oscenewexam2examinfo: {
    method: 'post',
    url: 'oscenewexam2/examinfo'
  },
  // 考试列表基础查看
  oscenewexamquery2exambaseinfo: {
    method: 'get',
    url: 'oscenewexamquery2/exambaseinfo'
  },
  // 考站设置-考站树
  oscenewexamquery2menutree: {
    method: 'get',
    url: 'oscenewexamquery2/menutree'
  },
  // 考站设置-保存
  oscenewexam2examstation: {
    method: 'post',
    url: 'oscenewexam2/examstation'
  },
  // 考站设置-详情
  oscenewexamquery2examstation: {
    method: 'get',
    url: 'oscenewexamquery2/examstation'
  },
  // 考站设置-左侧树-考站-详情
  oscenewexamquery2examrooms: {
    method: 'get',
    url: 'oscenewexamquery2/examrooms'
  },
  // 考站设置-左侧树-考站-房间列表
  oscemanageroomlistoscemanageroom: {
    method: 'post',
    url: 'oscemanageroom/listoscemanageroom'
  },
  // 考站设置-左侧树-考站-保存
  oscenewexam2examrooms: {
    method: 'post',
    url: 'oscenewexam2/examrooms'
  },
  // 考站设置-考站-房间设置-查看/详情
  oscenewexamquery2examroomsetting: {
    method: 'get',
    url: 'oscenewexamquery2/examroomsetting'
  },
  // 考站设置-考站-房间设置-保存
  oscenewexam2examroomsetting: {
    method: 'post',
    url: 'oscenewexam2/examroomsetting'
  },
  // 考站设置-考站-公共区域-查看/详情
  oscenewexamquery2publicarea: {
    method: 'get',
    url: 'oscenewexamquery2/publicarea'
  },
  // 考站设置-考站-公共区域-保存
  oscenewexam2publicarea: {
    method: 'post',
    url: 'oscenewexam2/publicarea'
  },
  // 考站设置-公共区域-房间-查看/详情
  oscenewexamquery2publicarearoom: {
    method: 'get',
    url: 'oscenewexamquery2/publicarearoom'
  },
  // 考站设置-公共区域-房间-保存
  oscenewexam2publicarearoom: {
    method: 'post',
    url: 'oscenewexam2/publicarearoom'
  },
  // 考站设置-下一步
  oscenewexamquery2nextcheck: {
    method: 'get',
    url: 'oscenewexamquery2/nextcheck'
  },
  // 详情-用物清单
  oscenewexamquery2assetlist: {
    method: 'get',
    url: 'oscenewexamquery2/assetlist'
  },
  // 详情-用物清单下载/导出
  oscenewexamquery2assetlistexport: {
    method: 'get',
    url: 'oscenewexamquery2/assetlist/export'
  },
  // 详情-房间详情
  oscenewexamquery2roomdetail: {
    method: 'get',
    url: 'oscenewexamquery2/roomdetail'
  },
  // 考生安排-考生资料-列表
  oscemanageexamineeexaminee: {
    method: 'get',
    url: 'oscemanageexaminee/examinee'
  },
  // 考生安排-选择考生-保存
  oscemanageexamineeexamexaminee: {
    method: 'post',
    url: 'oscemanageexaminee/examexaminee'
  },
  // 考生安排-考生资料-删除
  oscemanageexamineedeleteexaminee: {
    method: 'get',
    url: 'oscemanageexaminee/deleteexaminee'
  },
  // 考生安排-下载模板-校内考生模板
  studentdownloadtemplate: {
    method: 'get',
    url: 'student/download/template'
  },
  // 考生安排-下载模板-校外考生模板
  studentdownloadoutsidetemplate: {
    method: 'get',
    url: 'student/download/outside/template'
  },
  // 考生安排-导入考生-导入校内学生
  oscemanageexamineeimportoscestudentstaff: {
    method: 'post',
    url: 'oscemanageexaminee/importoscestudentstaff'
  },
  // 考生安排-导入考生-导入校外学生
  oscemanageexamineeimportstudentoutside: {
    method: 'post',
    url: 'oscemanageexaminee/importstudentoutside'
  },
  // 考生安排-排考
  oscemanageexamineequerystuexamschedulelist: {
    method: 'get',
    url: 'oscemanageexaminee/querystuexamschedulelist'
  },
  // 考生安排-考生考试安排
  oscemanageexamineequeryexamineeplan: {
    method: 'post',
    url: 'oscemanageexaminee/queryexamineeplan'
  },
  // 考生名册-导出
  oscemanageexamineequeryexamineeplanexport: {
    method: 'get',
    url: 'oscemanageexaminee/queryexamineeplan/export'
  },
  // 详情-考试调度列表
  oscemanageexamineequeryexamschedulelist: {
    method: 'get',
    url: 'oscemanageexaminee/queryexamschedulelist'
  },
  // 考试指引-查看/详情
  oscemanageexamineequeryexamineeguide: {
    method: 'get',
    url: 'oscemanageexaminee/queryexamineeguide'
  },
  // 考试列表-作废
  oscenewexam2invalidateexam: {
    method: 'get',
    url: 'oscenewexam2/invalidateexam'
  },
  // 发送考试通知-查询
  oscemanageexamnoticequeryexamnoticeinfo: {
    method: 'get',
    url: 'oscemanageexamnotice/queryexamnoticeinfo'
  },
  // 发送考试通知-发送
  oscemanageexamnoticesendexamnotice: {
    method: 'post',
    url: 'oscemanageexamnotice/sendexamnotice'
  },
  // 考试指引-保存
  oscemanageexamineeaddexamineeguide: {
    method: 'post',
    url: 'oscemanageexaminee/addexamineeguide'
  },
  //病例列表
  clinicalcaselist: {
    method: 'get',
    url: 'clinical/case/list'
  },
  //下载模板下载
  exportexportExcelMould: {
    method: 'get',
    url: 'export/exportExcelMould'
  },
  //病例导入
  clinicalcaseimport: {
    method: 'post',
    url: 'clinical/case/import'
  },
  //病例复制
  clinicalcasecopy: {
    method: 'get',
    url: 'clinical/case/copy'
  },
  //病例发布
  clinicalcasepublish: {
    method: 'get',
    url: 'clinical/case/publish'
  },
  //病例删除
  clinicalcasedelete: {
    method: 'get',
    url: 'clinical/case/delete'
  },
  //一般资料-保存
  clinicalcaseInfosave: {
    method: 'post',
    url: 'clinical/caseInfo/save'
  },
  //一般资料-查看
  clinicalcaseInfodetail: {
    method: 'get',
    url: 'clinical/caseInfo/detail'
  },
  //患者信息-保存
  clinicalcasePatientsave: {
    method: 'post',
    url: 'clinical/casePatient/save'
  },
  //一般资料-查看
  clinicalcasePatientdetail: {
    method: 'get',
    url: 'clinical/casePatient/detail'
  },
  //考试列表-复制
  oscenewexam2copyexam: {
    method: 'get',
    url: 'oscenewexam2/copyexam'
  },
  //基本信息-考试列表
  oscenewexamquery2allexamlist: {
    method: 'get',
    url: 'oscenewexamquery2/allexamlist'
  },
  //开始考试
  oscemanagecenterstart: {
    method: 'get',
    url: 'oscemanagecenter/start'
  },
  //考场状态
  oscemanagecenterexamstatus: {
    method: 'get',
    url: 'oscemanagecenter/exam/status'
  },
  //考生统计
  oscemanagecenterstudentstatistic: {
    method: 'get',
    url: 'oscemanagecenter/student/statistic'
  },
  //考站监控
  oscemanagecenterstationmonitor: {
    method: 'get',
    url: 'oscemanagecenter/station/monitor'
  },
  // 考生监控
  oscemanagecenterstudentmonitor: {
    method: 'get',
    url: 'oscemanagecenter/student/monitor'
  },
  // 待考学生
  oscemanagecenterreadystudent: {
    method: 'get',
    url: 'oscemanagecenter/ready/student'
  },
  // 设置缺考/确认缺考
  oscemanagecentermissset: {
    method: 'get',
    url: 'oscemanagecenter/miss/set'
  },
  // 缺考学生
  oscemanagecentermissstudent: {
    method: 'get',
    url: 'oscemanagecenter/miss/student'
  },
  // 设备监控
  oscemanagecenterdevicemonitor: {
    method: 'get',
    url: 'oscemanagecenter/device/monitor2'
  },
  // 评价列表
  spremarkstulist: {
    method: 'get',
    url: 'sp/remark/stu/list'
  },
  // 提交评价
  spremarkstusubmit: {
    method: 'post',
    url: 'sp/remark/stu/submit'
  },
  //  评价详情
  spremarkstudetail: {
    method: 'post',
    url: 'sp/remark/stu/detail'
  },
  //  一场线上考试评价记录列表
  spremarkstuexamlist: {
    method: 'get',
    url: 'sp/remark/stu/exam/list'
  },
  //  学生列表
  oscereportstudentlist: {
    method: 'get',
    url: 'osce/report/student/list'
  },
  //  考官列表
  oscereportexaminerlist: {
    method: 'get',
    url: 'osce/report/examiner/list'
  },
  //  考官报告
  oscereportexaminer: {
    method: 'get',
    url: 'osce/report/examiner'
  },
  //  学生报告
  oscereportonestudent: {
    method: 'get',
    url: 'osce/report/one/student'
  },
  //  管理者报告
  oscereportmanager: {
    method: 'get',
    url: 'osce/report/manager'
  },
  //  考试成绩监控
  oscereportscoremonitor: {
    method: 'get',
    url: 'osce/report/score/monitor'
  },
  //   临时增加考生
  oscemanagecenteraddstudent: {
    method: 'post',
    url: 'oscemanagecenter/add/student'
  },
  //   学生列表-检索条件-专业
  oscereportstudentlistmajor: {
    method: 'get',
    url: 'osce/report/student/list/major'
  },
  //   学生列表-检索条件-班级
  oscereportstudentlistclass: {
    method: 'get',
    url: 'osce/report/student/list/class'
  },
  //   学生列表-导出
  oscereportstudentexport: {
    method: 'get',
    url: 'osce/report/student/export'
  },
  //   一键结束和取消（动态调度）
  oscemanagecenterstudentoverset: {
    method: 'get',
    url: 'oscemanagecenter/student/over/set'
  },
  //   暂停考试/取消暂停考试
  oscemanagecenterexamstopset: {
    method: 'get',
    url: 'oscemanagecenter/exam/stop/set'
  },
  //   管理者报告-学生成绩列表
  oscereportstudentscorelist: {
    method: 'get',
    url: 'osce/report/student/score/list'
  },
  //   课表：列表
  coursequerycourseinfo: {
    method: 'post',
    url: 'course/querycourseinfo'
  },
  //   学期列表
  semesterlistsesemterinfo: {
    method: 'get',
    url: 'semester/listsesemterinfo'
  },
  //   场地使用率-周日历-场地列表
  sitesitelist: {
    method: 'get',
    url: 'site/sitelist'
  },
  //   课表：查看
  coursequerycoursedetailinfo: {
    method: 'get',
    url: 'course/querycoursedetailinfo'
  },
  //   学历
  levelquerylevel: {
    method: 'get',
    url: 'level/querylevel'
  },
  // 关联教师-已关联教师列表
  coursev2querycoursesteacher: {
    method: 'post',
    url: 'coursev2/querycoursesteacher'
  },
  // 课程
  coursev2querycoursenamelist: {
    method: 'get',
    url: 'coursev2/querycoursenamelist'
  },
  // 课程内容
  coursev2querycontent: {
    method: 'get',
    url: 'coursev2/querycontent'
  },
  // learn/isschedulemerge
  learnisschedulemerge: {
    method: 'post',
    url: 'learn/isschedulemerge'
  },
  // 多教师的所有群组列表
  groupteacherslist: {
    method: 'post',
    url: 'group/teachers/list'
  },
  // 课表：新增
  courseaddcourseinfo: {
    method: 'post',
    url: 'course/addcourseinfo'
  },
  // 课表：修改
  courseupdatecourseinfo: {
    method: 'post',
    url: 'course/updatecourseinfo'
  },
  // 课表：删除
  coursedeletecourseinfo: {
    method: 'get',
    url: 'course/deletecourseinfo'
  },
  // 门列表
  dooraccesscontrolfinddooraccess: {
    method: 'post',
    url: 'dooraccesscontrol/finddooraccess'
  },
  // 查询拥有某门禁权限的用户(分页查询)
  dooraccesscontrolfinddooruser: {
    method: 'get',
    url: 'dooraccesscontrol/finddooruser'
  },
  // 可供添加的用户列表
  dooraccesscontroluserlist: {
    method: 'get',
    url: 'dooraccesscontrol/userlist'
  },
  // 新增门禁用户
  dooraccesscontroladddooruser: {
    method: 'post',
    url: 'dooraccesscontrol/adddooruser'
  },
  // 删除门禁用户
  dooraccesscontroldeletedooruser: {
    method: 'get',
    url: 'dooraccesscontrol/deletedooruser'
  },
  // 开门
  dooraccesscontrolappopendoor: {
    method: 'get',
    url: 'dooraccesscontrol/appopendoor'
  },
  // 开门记录
  dooraccesscontrolqueryopenrecord: {
    method: 'get',
    url: 'dooraccesscontrol/queryopenrecord'
  },
  // 新增/编辑
  questionnaireadd: {
    method: 'post',
    url: 'questionnaire/add'
  },
  // 列表
  questionnairelist: {
    method: 'get',
    url: 'questionnaire/list'
  },
  // 详情
  questionnairedetail: {
    method: 'get',
    url: 'questionnaire/detail'
  },
  // 删除
  questionnairedelete: {
    method: 'get',
    url: 'questionnaire/delete'
  },
  // 启用/停用
  questionnaireupdatestatus: {
    method: 'get',
    url: 'questionnaire/update/status'
  },
  // 复制
  questionnairecopy: {
    method: 'get',
    url: 'questionnaire/copy'
  },
  // 问卷
  questionnairelist: {
    method: 'get',
    url: 'questionnaire/list'
  },
  // 我的评卷
  videorecordingscorelist: {
    method: 'get',
    url: 'video/recording/score/list'
  },
  // 考站房间列表
  videorecordingscoreroomlist: {
    method: 'get',
    url: 'video/recording/score/room/list'
  },
  // 学生列表
  videorecordingscorestudentlist: {
    method: 'get',
    url: 'video/recording/score/student/list'
  },
  // 评分界面：视频信息
  videorecordingscorevideolist: {
    method: 'get',
    url: 'video/recording/score/video/list'
  },
  // 评分界面：视频信息
  videorecordingscorevideolist: {
    method: 'get',
    url: 'video/recording/score/video/list'
  },
  // 根据题目id查询题目详情
  osceexamquestionlist: {
    method: 'get',
    url: 'osce/exam/question/list'
  },
  // 评分界面：获取视频截图
  videoscreenshot: {
    method: 'get',
    url: 'video/screenshot'
  },
  // 评分界面：获取视频截图
  videorecordingcommentadd: {
    method: 'post',
    url: 'video/recording/comment/add'
  },
  // 评分界面：查看评语
  recordingcommentget: {
    method: 'get',
    url: 'video/recording/comment/get'
  },
  // 查询签名
  osceexamsigninfo: {
    method: 'get',
    url: 'osce/exam/sign/info'
  },
  // 评分界面：提交成绩
  osceexamsubmitscore: {
    method: 'post',
    url: 'osce/exam/submit/score'
  },
  // 班级：专业名称-年级-班级名称拼接列表
  classsimplelist: {
    method: 'get',
    url: 'class/simple/list'
  },
  // 单位管理员：问诊记录
  trainrecordlist: {
    method: 'get',
    url: 'train/record/list'
  },
  // 单位管理员：月统计列表
  consultationmanagermonthlist: {
    method: 'get',
    url: 'consultation/manager/month/list'
  },
  // 结束问诊
  trainarrangerover: {
    method: 'get',
    url: 'train/arranger/over'
  },
  // 评分界面：查看评语-删除一次评语
  videorecordingcommentdelete: {
    method: 'get',
    url: 'video/recording/comment/delete'
  },
  // 我的考试列表
  oscestudentexamlist: {
    method: 'get',
    url: 'osce/student/exam/list'
  },
  // 资讯列表
  officialnewslist: {
    method: 'get',
    url: 'official/news/list'
  },
  // 资讯编辑
  officialnewsedit: {
    method: 'post',
    url: 'official/news/edit'
  },
  // 资讯查看
  officialnewsdetail: {
    method: 'get',
    url: 'official/news/detail'
  },
  // 活动通知列表
  officialnoticelist: {
    method: 'get',
    url: 'official/notice/list'
  },
  // 活动通知查看
  officialnoticedetail: {
    method: 'get',
    url: 'official/notice/detail'
  },
  // SP预约列表
  officialsparrangelist: {
    method: 'get',
    url: 'official/sp/arrange/list'
  },
  // 课程列表
  traincourselist: {
    method: 'get',
    url: 'train/course/list'
  },
  // 课程详情
  traincoursedetail: {
    method: 'get',
    url: 'train/course/detail'
  },
  // 课程发布/下架
  traincoursepublish: {
    method: 'get',
    url: 'train/course/publish'
  },
  // 课程下章节列表
  traincoursechapterlist: {
    method: 'get',
    url: 'train/course/chapter/list'
  },
  // 课程下章节编辑
  trainchapteredit: {
    method: 'post',
    url: 'train/chapter/edit'
  },
  // 导入习题模板
  trainquestionimport: {
    method: 'post',
    url: 'train/question/import'
  },
  // 章节删除
  trainchapterdelete: {
    method: 'get',
    url: 'train/chapter/delete'
  },
  // 下载习题模板
  trainquestiondownload: {
    method: 'get',
    url: 'train/question/download'
  },
  // 课程删除
  traincoursedelete: {
    method: 'get',
    url: 'train/course/delete'
  },
  // 章节详情
  trainchapterdetail: {
    method: 'get',
    url: 'train/chapter/detail'
  },
  // 上移/下移动
  traincoursechaptermove: {
    method: 'get',
    url: 'train/course/chapter/move'
  },
  // 习题统计
  trainquestionstatistics: {
    method: 'get',
    url: 'train/question/statistics'
  },
  // 习题统计列表
  trainquestionscorelist: {
    method: 'get',
    url: 'train/question/score/list'
  },
  // 习题统计详情
  trainquestionscoredetail: {
    method: 'get',
    url: 'train/question/score/detail'
  },
  // 章节发布/下架
  trainchapterpublish: {
    method: 'get',
    url: 'train/chapter/publish'
  },
  // 删除习题
  trainquestiondelete: {
    method: 'get',
    url: 'train/question/delete'
  },
  traincertificatelist: {
    method: 'get',
    url: 'train/certificate/list'
  },
  commparaconfdetail: {
    method: 'get',
    url: 'commparaconf/detail'
  },
  // 提交认证审核
  traincertificateapprove: {
    method: 'post',
    url: 'train/certificate/approve'
  },
  // 数据概览
  traincourseoverview: {
    method: 'get',
    url: 'train/course/overview'
  },
  // 消息列表
  messagelist: {
    method: 'get',
    url: 'message/list'
  },
  // 查询消息接收人
  messagesenduserlist: {
    method: 'post',
    url: 'message/send/user/list'
  },
  // 查询短信模板列表
  messagetemplatelist: {
    method: 'get',
    url: 'message/template/list'
  },
  // 消息发布
  messageadd: {
    method: 'post',
    url: 'message/add'
  },
  // 消息查看
  messagedetail: {
    method: 'get',
    url: 'message/detail'
  },
  // 消息删除
  messagedelete: {
    method: 'get',
    url: 'message/delete'
  },
  //取消和确认借出、归还、接收、领用
  updateconfirmStatus: {
    method: 'get',
    url: 'assetLendObtain/admin/update/confirmStatus'
  },
  //作业管理-列表
  companionhomeworklist: {
    method: 'get',
    url: 'companion/homework/list'
  },
  //作业管理-详情
  companionhomeworkdetail: {
    method: 'get',
    url: 'companion/homework/detail'
  },
  //提交评分
  companionsubmitstudentscore: {
    method: 'post',
    url: 'companion/submit/student/score'
  },
  //字幕-添加字幕
  videocaptionsadd: {
    method: 'get',
    url: 'video/captions/add'
  },
  //作业管理-标记为同侪推荐
  companionhomeworkclassic: {
    method: 'get',
    url: 'companion/homework/classic'
  },
  //作业管理-教师添加评语
  companionhomeworkscorecommentadd: {
    method: 'post',
    url: 'companion/homework/score/comment/add'
  },
  //作业管理-教师添加评语
  companionhomeworkclassiclist: {
    method: 'get',
    url: 'companion/homework/classic/list'
  },
  //获取登录用户信息
  usermyinfo: {
    method: 'get',
    url: 'user/my/info'
  },
  //评分表：导出
  scoretableexport: {
    method: 'get',
    url: 'score/table/export'
  },
  //网站/小程序-课程分类
  traincourseclassifyIdquery: {
    method: 'get',
    url: 'train/course/classifyId/query'
  },
  //危化品开关
  commparaconfdetail: {
    method: 'get',
    url: 'commparaconf/detail'
  },
  //课程编辑2（版本2）
  trainchapteredit2: {
    method: 'post',
    url: 'train/chapter/edit2'
  },
  // 课程开放-课程列表
  traincourseopencourse: {
    method: 'get',
    url: 'train/course/open/course'
  },
  // 课程开放-单位列表
  traincourseopencompany: {
    method: 'get',
    url: 'train/course/open/company'
  },
  // 课程开放-设置
  traincourseopen: {
    method: 'post',
    url: 'train/course/open'
  },
  // 举报管理
  reportingmanagement: {
    method: 'get',
    url: 'online/complaint/list'
  },
  // 举报管理-回复
  reportingreply: {
    method: 'get',
    url: 'online/complaint/reply'
  },
  // 举报管理-修改当前状态
  reportingreplyupdate: {
    method: 'get',
    url: 'online/complaint/update/status'
  },
  // 热门管理
  hotmanagelist: {
    method: 'get',
    url: 'online/topic/hot/manage/list'
  },
  // 热门管理-创建话题
  hottopicadd: {
    method: 'get',
    url: 'online/topic/add'
  },
  // 热门管理-上下架
  hotdownAndUp: {
    method: 'get',
    url: 'online/topic/downAndUp'
  },
  // 热门管理-置顶/取消置顶
  hottoppingAndCancel: {
    method: 'get',
    url: 'online/topic/toppingAndCancel'
  },
  // 帖子管理
  cardlist: {
    method: 'get',
    url: '/online/card/manage/list'
  },
  // 帖子管理-上架
  cardup: {
    method: 'get',
    url: 'online/card/up'
  },
  // 帖子管理-下架
  carddown: {
    method: 'get',
    url: 'online/card/down'
  },
  // 帖子管理-删除
  carddelete: {
    method: 'get',
    url: 'online/card/delete'
  },
  // 帖子管理-详情
  carddetail: {
    method: 'get',
    url: 'online/card/detail'
  },
  // 帖子管理-详情-点赞
  onlinecardthumbs: {
    method: 'get',
    url: 'online/card/thumbs'
  },
  // 帖子管理-详情-收藏
  onlinecardcollect: {
    method: 'get',
    url: 'online/card/collect'
  },
  // 帖子管理-详情-评论列表
  onlinecardcommentlist: {
    method: 'get',
    url: 'online/card/comment/list'
  },
  // 帖子删除
  onlinecardcommentdelete: {
    method: 'get',
    url: 'online/card/comment/delete'
  },
  // 帖子-发表评论
  onlinecardcommentadd: {
    method: 'post',
    url: 'online/card/comment/add'
  },
  // 帖子-评论点赞
  onlinecardcommentthumbs: {
    method: 'get',
    url: 'online/card/comment/thumbs'
  },
  // osce考试分析
  bigoscereport: {
    method: 'get',
    url: 'big/osce/report'
  },
  // 大屏主题列表
  bigscreenlist: {
    method: 'get',
    url: 'big/screen/list'
  },
  // 大屏主题列表-新增、修改
  bigscreenedit: {
    method: 'post',
    url: 'big/screen/edit'
  },
  // 大屏主题列表-删除
  bigscreendelete: {
    method: 'get',
    url: 'big/screen/delete'
  },
  // 大屏主题库列表
  bigthemelist: {
    method: 'get',
    url: 'big/theme/list'
  },
  // 大屏主题库状态修改
  bigthemeupdateStatus: {
    method: 'get',
    url: 'big/theme/updateStatus'
  },
  // 大屏主题详情
  bigscreendetail: {
    method: 'get',
    url: 'big/screen/detail'
  },
  // 线上考试报告
  bigexamreport: {
    method: 'get',
    url: 'big/exam/report'
  },
  // 线下考试报告
  bigofflinereport: {
    method: 'get',
    url: 'big/offline/report'
  },
  // 主题2-技能训练
  bigskillreport: {
    method: 'get',
    url: 'big/skill/report'
  },
  // 主题3-在线训练
  bigonlinereport: {
    method: 'get',
    url: 'big/online/report'
  },
  // 主题4-智能设备训练
  bigdevicereport: {
    method: 'get',
    url: 'big/device/report'
  },
  // 主题4-智能设备训练-实时数据
  bigdevicerealStatus: {
    method: 'get',
    url: 'big/device/realStatus'
  },
  // 主题5-同侪互评
  bigcompanionreport: {
    method: 'get',
    url: 'big/companion/report'
  },
  // 主题5-同侪互评-实时数据
  bigcompanionrealStatus: {
    method: 'get',
    url: 'big/companion/realStatus'
  },
  // 主题6-运营实时状态
  bigoperatereport: {
    method: 'get',
    url: 'big/operate/report'
  },
  // 主题7-运营实时状态
  bigsubject7report: {
    method: 'get',
    url: 'big/subject7/report'
  },
  // 主题8-胜任力-注册学生数量和在职教师数量
  bigsubject8student: {
    method: 'get',
    url: 'big/subject8/student'
  },
  // 主题8-胜任力-技能训练人次和学期课程
  bigsubject8skill: {
    method: 'get',
    url: 'big/subject8/skill'
  },
  // 主题8-胜任力
  bigsubject8competency: {
    method: 'get',
    url: 'big/subject8/competency'
  },
  // 主题9-同侪互评训练数据实时分析-个人
  bigsubject9student: {
    method: 'get',
    url: 'big/subject9/student'
  },
  // 主题9-同侪互评训练数据实时分析-空闲
  bigsubject9skill: {
    method: 'get',
    url: 'big/subject9/skill'
  },
  // 主题10-学生管理
  bigsubject10report: {
    method: 'get',
    url: 'big/subject10/report'
  },
  // 主题11-教育资源分析
  bigsubject11report: {
    method: 'get',
    url: 'big/subject11/report'
  },
  // 主题12-课表轮播
  bigsubject12report: {
    method: 'get',
    url: 'big/subject12/report'
  },
  // 主题16-码上评报告
  bigcodereport: {
    method: 'get',
    url: 'big/code/report'
  },
  // 主题17-SP统计
  bigconsultationreport: {
    method: 'get',
    url: 'big/consultation/report'
  },
  // 问诊次数设置：保存
  arrangenumlimitsave: {
    method: 'post',
    url: 'arrange/num/limit/save'
  },
  // 问诊次数设置：详情
  arrangenumlimitdetail: {
    method: 'get',
    url: 'arrange/num/limit/detail'
  },
  // 问诊次数设置：按日单次保存
  arrangenumlimitdayadd: {
    method: 'post',
    url: 'arrange/num/limit/day/add'
  },
  // 问诊次数设置：按日单次列表
  arrangenumlimitdaylist: {
    method: 'get',
    url: 'arrange/num/limit/day/list'
  },
  // 问诊次数设置：按日单次删除
  arrangenumlimitdaydelete: {
    method: 'get',
    url: 'arrange/num/limit/day/delete'
  },
  // 问诊次数设置：按日单次保存
  arrangenumlimitdayadd: {
    method: 'post',
    url: 'arrange/num/limit/day/add'
  },
  // 问诊次数设置：查询是否超出问诊次数限制
  arrangenumlimitcanarrange: {
    method: 'get',
    url: 'arrange/num/limit/can/arrange'
  },
  // 问诊:预约验证
  onlineconsultationarrangespcheck: {
    method: 'post',
    url: 'online/consultation/arrange/sp/check'
  },
  // 网站/小程序-课程分类（树结构）
  traincourseclassifyIdtree: {
    method: 'get',
    url: 'train/course/classifyId/tree'
  },
  // 课程列表接口（课程管理）
  traincoursemanagerlist: {
    method: 'get',
    url: 'train/course/manager/list'
  },
  // 学期课程教师班级关联记录列表
  teachevalrelationlist: {
    method: 'post',
    url: 'teach/eval/relation/list'
  },
  // 学期课程教师班级关联记录列表-新增
  teachevalrelationadd: {
    method: 'post',
    url: 'teach/eval/relation/add'
  },
  // 学期课程教师班级关联记录列表-删除
  teachevalrelationdelete: {
    method: 'get',
    url: 'teach/eval/relation/delete'
  },
  // 学期课程教师班级关联-模板下载
  teachevalrelationdownloadtemplate: {
    method: 'get',
    url: 'teach/eval/relation/download/template'
  },
  // 学期课程教师班级关联-导入
  teachevalrelationimport: {
    method: 'post',
    url: 'teach/eval/relation/import'
  },
  // 评教记录列表
  teachevallist: {
    method: 'post',
    url: 'teach/eval/list'
  },
  // 提交评教 学期列表
  teachevaltermlist: {
    method: 'get',
    url: 'teach/eval/term/list'
  },
  // 提交评教 课程列表
  teachevalcourselist: {
    method: 'get',
    url: 'teach/eval/course/list'
  },
  // 提交评教 教师列表
  teachevalteacherlist: {
    method: 'get',
    url: 'teach/eval/teacher/list'
  },
  // 查询评教评分表id
  commparaconfdetail: {
    method: 'get',
    url: 'commparaconf/detail'
  },
  // 提交
  teachevalsubmit: {
    method: 'post',
    url: 'teach/eval/submit'
  },
  // 单次评教详情
  teachevalscoredetail: {
    method: 'get',
    url: 'teach/eval/score/detail'
  },
  // 教师课程得分列表
  teachevalteacherscorelist: {
    method: 'post',
    url: 'teach/eval/teacher/score/list'
  },
  // 未评教学生列表
  teachevalunScorelist: {
    method: 'post',
    url: 'teach/eval/unScore/list'
  },
  // 查询评教记录-学期列表
  teachevalquerytermlist: {
    method: 'get',
    url: 'teach/eval/query/term/list'
  },
  // 查询评教记录-课程列表
  teachevalquerycourselist: {
    method: 'post',
    url: 'teach/eval/query/course/list'
  },
  // 查询评教记录-教师列表
  teachevalqueryteacherlist: {
    method: 'post',
    url: 'teach/eval/query/teacher/list'
  },
  // 教师课程得分列表-统计报告
  teachevalteacherscoredetail: {
    method: 'post',
    url: 'teach/eval/teacher/score/detail'
  },
  // 评教记录列表-导出excel
  teachevallistexport: {
    method: 'post',
    url: 'teach/eval/list/export'
  },
  //  群组:批量导入群组模板下载
  groupdownloadtemplate: {
    method: 'get',
    url: 'group/download/template'
  },
  //  群组:批量导入群组
  groupimportgroups: {
    method: 'post',
    url: 'group/import/groups'
  },
  // 下载随堂测试模板
  groupdownloadcodetemplate: {
    method: 'get',
    url: 'group/download/code/template'
  },
  //  批量导入随堂测试
  groupimportcodegroups: {
    method: 'post',
    url: 'group/import/code/groups'
  },
  // 随堂测试-群组-添加
  codetestgroupadd: {
    method: 'post',
    url: 'code/test/group/add'
  },
  // 随堂测试-群组-群组列表
  codetestgrouplist: {
    method: 'get',
    url: 'code/test/group/list'
  },
  // 随堂测试-群组-删除
  codetestgroupdelete: {
    method: 'post',
    url: 'code/test/group/delete'
  },
  // 码上评-发布任务
  codepublish: {
    method: 'get',
    url: 'code/publish'
  },
  // 随堂测试-考核内容-添加
  codetestgroupsetadd: {
    method: 'post',
    url: 'code/test/group/set/add'
  },
  // 随堂测试-考核内容-列表
  codetestgroupsetlist: {
    method: 'get',
    url: 'code/test/group/set/list'
  },
  // 随堂测试-评分表-列表
  codeteststelist: {
    method: 'get',
    url: 'code/test/ste/list'
  },
  // 随堂测试-评分表-列表
  codeteststedownloadtemplate: {
    method: 'get',
    url: 'code/test/ste/download/template'
  },
  // 随堂测试-评分表-模板导入
  codeteststetemplateimport: {
    method: 'post',
    url: 'code/test/ste/template/import'
  },
  // 随堂测试-考核内容-导出
  codeteststeexport: {
    method: 'get',
    url: 'code/test/ste/export'
  },
  // 随堂测试-学生-列表
  codeteststudentlist: {
    method: 'get',
    url: 'code/test/student/list'
  },
  // 学生-列表
  studentsearchaccountAndName: {
    method: 'get',
    url: 'student/search/accountAndName'
  },
  // 随堂测试-学生-添加
  codeteststudentadd: {
    method: 'get',
    url: 'code/test/student/add'
  },
  // 随堂测试-学生-删除
  codeteststudentdelete: {
    method: 'get',
    url: 'code/test/student/delete'
  },
  // 随堂测试-学生-删除
  codeteststudentlistexport: {
    method: 'get',
    url: 'code/test/student/list/export'
  },
  // 后台-充值订单-列表
  perchargerecordlist: {
    method: 'get',
    url: 'per/charge/record/list'
  },
  // 后台-充值总金额和总订单数
  perchargetotalmoneyquery: {
    method: 'get',
    url: 'per/charge/total/money/query'
  },
  //  后台-消费订单-列表
  perconsumerecordlist: {
    method: 'get',
    url: 'per/consume/record/list'
  },
  // 后台-消费总金额和总订单数
  perconsumetotalmoneyquery: {
    method: 'get',
    url: 'per/consume/total/money/query'
  },
  // 评分表：发布和取消发布
  scoretablepublishset: {
    method: 'get',
    url: 'score/table/publish/set'
  },
  // 广场管理-置顶和取消置顶
  onlinecardtoppingset: {
    method: 'get',
    url: 'online/card/topping/set'
  },
  // 广场管理-banner
  bannersplist: {
    method: 'get',
    url: 'banner/sp/list'
  },
  // 广场管理-banner修改展示状态
  bannerspupdatestatus: {
    method: 'get',
    url: 'banner/sp/update/status'
  },
  // 广场管理-banner编辑
  bannerspedit: {
    method: 'post',
    url: 'banner/sp/edit'
  },
  // 广场管理-banner详情
  bannerspdetail: {
    method: 'get',
    url: 'banner/sp/detail'
  },
  // 广场管理-banner删除
  bannerspdelete: {
    method: 'get',
    url: 'banner/sp/delete'
  },
  // 设置和取消设置医教相伴首页弹框
  bannersppopset: {
    method: 'get',
    url: 'banner/sp/pop/set'
  },
  // 后台-售后订单-列表
  perafterSalesrecordlist: {
    method: 'get',
    url: 'per/afterSales/record/list'
  },
  // 后台-售后总金额和总订单数
  perafterSalestotalmoneyquery: {
    method: 'get',
    url: 'per/afterSales/total/money/query'
  },
  // 后台-售后订单- 回复
  perafterSalesreply: {
    method: 'get',
    url: 'per/afterSales/reply'
  },
  // 后台-售后订单-退款
  perafterSalesrefund: {
    method: 'get',
    url: 'per/afterSales/refund'
  },
  // 后台-售后订单-修改订单状态
  perafterSalesupdatestatus: {
    method: 'get',
    url: 'per/afterSales/update/status'
  },
  // 直播间实时监控
  bigrealtimeallroom: {
    method: 'get',
    url: 'big/realtime/all/room'
  },
  //查询SP未开始的最近一次预约
  onlineconsultationsplatestArrangeRecord: {
    method: 'get',
    url: 'online/consultation/sp/latestArrangeRecord'
  },
  //sp导入模版下载
  spdownloadtemplate: {
    method: 'get',
    url: 'sp/download/template'
  },
  //sp导入
  spimport: {
    method: 'post',
    url: 'sp/import'
  },
  //sp导出
  spexport: {
    method: 'get',
    url: 'sp/export'
  },
  //超级管理员-个人管理
  peruserlist: {
    method: 'get',
    url: 'per/user/list'
  },
  //邀请人列表
  perinviteinviteelist: {
    method: 'get',
    url: 'per/invite/invitee/list'
  },
  //出示门诊资料
  trainshowoutpatientcases: {
    method: 'get',
    url: 'train/show/outpatient/cases'
  },
  //用姓名查询学生教师列表
  userstuAndTealist: {
    method: 'get',
    url: 'user/stuAndTea/list'
  },

  // cos文件地址保存
  cosurlsave: {
    method: 'post',
    url: 'cos/url/save'
  },
  // 管理直播列表
  livemanagelist: {
    method: 'get',
    url: 'live/manage/list'
  },
  // 直播讲座管理
  livemanageedit: {
    method: 'post',
    url: 'live/manage/edit'
  },
  // 直播讲座详情
  livemanagedetail: {
    method: 'get',
    url: 'live/manage/detail'
  },
  // 状态修改（发布、取消发布、删除、结束）
  livemanageupdatestatus: {
    method: 'get',
    url: 'live/manage/update/status'
  },
  // 保存某个直播的课程表
  livemanagescheduleupdate: {
    method: 'post',
    url: 'live/manage/schedule/update'
  },
  // 获取某直播报名人列表
  livemanageschedulelist: {
    method: 'get',
    url: 'live/manage/schedule/list'
  },
  // 获取某直播报名人列表
  livemanageapplicantlist: {
    method: 'get',
    url: 'live/manage/applicant/list'
  },
  // 删除某直播下的某个主讲人
  livemanagedeletespeaker: {
    method: 'get',
    url: 'live/manage/delete/speaker'
  },
  // 实时音视频录制权限查询
  trtcroomqueryvideorecord: {
    method: 'get',
    url: 'trtc/room/query/video/record'
  },
  // 给直播讲座报名人发送短信消息
  livemanagesendmessage: {
    method: 'get',
    url: 'live/manage/send/message'
  },
  // 获取某直播报名人列表
  livemanageapplicantlist: {
    method: 'get',
    url: 'live/manage/applicant/list'
  },
  // 获取不限制的小程序码
  wechatgetUnlimitedQRCode: {
    method: 'post',
    url: 'wechat/getUnlimitedQRCode'
  },
  // 关闭某用户其他端的实时音视频
  trtcroomsendleaveRoomMsg: {
    method: 'get',
    url: 'trtc/room/send/leaveRoomMsg'
  },
  // 查询用户是否在直播间状态
  trtcroomgetUserRoomStatus: {
    method: 'get',
    url: 'trtc/room/getUserRoomStatus'
  },
  // 通用-评论列表
  commentlist: {
    method: 'get',
    url: 'comment/list'
  },
  // 通用-提交评论
  commentadd: {
    method: 'post',
    url: 'comment/add'
  },
  // 通用-删除评论
  commentdelete: {
    method: 'get',
    url: 'comment/delete'
  },
  // 通用-对一级评论点赞
  commentthumbs: {
    method: 'get',
    url: 'comment/thumbs'
  },
  // 获取标准评分表名称列表
  scoretablegetstandardlist: {
    method: 'get',
    url: 'score/table/get/standard/list'
  },
  // 编辑标准评分表名称
  scoretableeditstandard: {
    method: 'get',
    url: 'score/table/edit/standard'
  },
  // 编辑评分表和标准名称的关联关系
  scoretableeditstandardrel: {
    method: 'get',
    url: 'score/table/edit/standard/rel'
  },
  // 获取cos签名信息
  cosgetSign: {
    method: 'get',
    url: 'cos/getSign'
  },
  // 发帖-获取帖子的cos签名信息
  cosgetAuditingSign: {
    method: 'get',
    url: 'cos/getAuditingSign'
  },
  // 获取被点评文件(通用)
  commoncommentgetfile: {
    method: 'post',
    url: 'common/comment/get/file'
  },
  // 查看评语(通用)
  commoncommentdetail: {
    method: 'post',
    url: 'common/comment/detail'
  },
  // 添加评语(通用)
  commoncommentadd: {
    method: 'post',
    url: 'common/comment/add'
  },
  // 删除评语（通用）
  commoncommentdelete: {
    method: 'get',
    url: 'common/comment/delete'
  },
  // 菜单组管理：列表
  menugrouplist: {
    method: 'get',
    url: 'menu/group/list'
  },
  // 菜单组管理：删除
  menugroupdelete: {
    method: 'get',
    url: 'menu/group/delete'
  },
  // 获取菜单组和菜单关联详情
  menugroupgetMenuGroupAndMenuRel: {
    method: 'get',
    url: 'menu/group/getMenuGroupAndMenuRel'
  },
  // 编辑菜单组和菜单的关联
  menugroupeditMenuGroupAndMenuRel: {
    method: 'get',
    url: 'menu/group/editMenuGroupAndMenuRel'
  },
  // 菜单组管理：编辑
  menugroupedit: {
    method: 'post',
    url: 'menu/group/edit'
  },
  // 编辑角色和菜单组的关联
  menugroupeditRoleAndMenuGroupRel: {
    method: 'post',
    url: 'menu/group/editRoleAndMenuGroupRel'
  },
  // 查询话题分类
  commparaconfquerycommparaconflist: {
    method: 'get',
    url: 'commparaconf/querycommparaconflist'
  },
  // 5刪除视频时间点题目
  trainquestionvideodelete: {
    method: 'get',
    url: 'train/question/video/delete'
  },
  // 实时计划管理：下载成绩
  evaluationplanprojectexport: {
    method: 'get',
    url: 'evaluation/plan/project/export'
  },
  // 更新带教老师评价
  planteacherupdate: {
    method: 'get',
    url: 'plan/teacher/update'
  },
  // 学生实习计划
  planstudentjoinlist: {
    method: 'post',
    url: 'plan/student/join/list'
  },
  // 病例的智能对话背景图查看
  casemodelChatquery: {
    method: 'get',
    url: 'case/modelChat/query'
  },
  // 病例的智能对话背景图设置
  casemodelChatset: {
    method: 'post',
    url: 'case/modelChat/set'
  },
  // 课程列表（关联使用）
  traincoursecodelist: {
    method: 'get',
    url: 'train/course/code/list'
  },
  // 关联课程资源-未关联课程资源列表
  coursestrainunRellist: {
    method: 'get',
    url: 'courses/train/unRel/list'
  },
  // 关联课程资源-已关联课程资源列表
  coursestrainrellist: {
    method: 'get',
    url: 'courses/train/rel/list'
  },
  // 关联课程资源-添加
  coursestrainreladd: {
    method: 'post',
    url: 'courses/train/rel/add'
  },
  // 关联课程资源-删除/批量删除
  coursestrainreldelete: {
    method: 'post',
    url: 'courses/train/rel/delete'
  },
  // 生成学期课程教师班级关联记录
  teachevalrelationgenerate: {
    method: 'post',
    url: 'teach/eval/relation/generate'
  },
  // 提交评教上课时间列表
  teachevalcoursetimelist: {
    method: 'post',
    url: 'teach/eval/course/time/list'
  },
  // 标签： 列表
  labquerylabinfolist2: {
    method: 'get',
    url: 'lab/querylabinfolist2'
  },
  // 标签：新增
  labaddlabinfo: {
    method: 'get',
    url: 'lab/addlabinfo'
  },
  // 标签：删除
  labdeletelabinfo: {
    method: 'get',
    url: 'lab/deletelabinfo'
  },
  // 查询资源的关键词和标签
  labqueryResourceLabAndKeyword: {
    method: 'get',
    url: 'lab/queryResourceLabAndKeyword'
  },
  // 训练用物-列表
  learntypequerylearnassets: {
    method: 'get',
    url: 'learntype/querylearnassets'
  },
  // 训练用物-保存
  learntyperelateassets: {
    method: 'post',
    url: 'learntype/relateassets'
  },
  // 专家-列表
  expertlist: {
    method: 'get',
    url: 'expert/list'
  },
  // 专家-列表
  expertedit: {
    method: 'post',
    url: 'expert/edit'
  },
  // 专家-查看
  expertdetail: {
    method: 'get',
    url: 'expert/detail'
  },
  // 专家-禁用
  spchangestatus: {
    method: 'get',
    url: 'sp/change/status'
  },
  // 专家-删除
  teacherdelete: {
    method: 'post',
    url: 'teacher/delete'
  },
  // 专家-重置密码
  teacherresetpassword: {
    method: 'get',
    url: 'teacher/reset/password'
  },
  // 专家-简单列表
  usersimplelist: {
    method: 'get',
    url: 'user/simple/list'
  },
  // 问诊任务-管理列表
  consultationtaskmanagelist: {
    method: 'get',
    url: 'consultation/task/manage/list'
  },
  // 问诊任务-编辑任务
  consultationtaskedit: {
    method: 'post',
    url: 'consultation/task/edit'
  },
  // 问诊任务-查看任务详情
  consultationtaskdetail: {
    method: 'get',
    url: 'consultation/task/detail'
  },
  // 问诊任务-删除任务
  consultationtaskdelete: {
    method: 'get',
    url: 'consultation/task/delete'
  },
  // 问诊任务-修改任务状态
  consultationtaskupdatestatus: {
    method: 'get',
    url: 'consultation/task/update/status'
  },
  // 问诊任务-查询学生任务统计列表
  consultationtaskreportstudentlist: {
    method: 'get',
    url: 'consultation/task/report/student/list'
  },
  // 问诊任务：查询指定任务下某学生报告
  consultationtaskstudentreportdetail: {
    method: 'get',
    url: 'consultation/task/student/report/detail'
  },
  // 问诊任务：查询指定任务报告
  consultationtaskreportdetail: {
    method: 'get',
    url: 'consultation/task/report/detail'
  },
  // 问诊任务：生成或更新某任务整体报告
  consultationtaskreportupdate: {
    method: 'get',
    url: 'consultation/task/report/update'
  },
  // 题库-科目：树
  questionsubjecttree: {
    method: 'get',
    url: 'question/subject/tree'
  },
  // 题库-科目：新增
  questionsubjectadd: {
    method: 'get',
    url: 'question/subject/add'
  },
  // 题库-科目：修改
  questionsubjectupdate: {
    method: 'get',
    url: 'question/subject/update'
  },
  // 题库-科目：删除
  questionsubjectdelete: {
    method: 'get',
    url: 'question/subject/delete'
  },
  // 题库-科目下模块列表
  questionsubjectmodulelist: {
    method: 'get',
    url: 'question/subject/module/list'
  },
  // 题库-模块-删除
  questionsubjectmoduledelete: {
    method: 'get',
    url: 'question/subject/module/delete'
  },
  // 题库-模块-新增
  questionsubjectmoduleadd: {
    method: 'get',
    url: 'question/subject/module/add'
  },
  // 题库-模块-更新
  questionsubjectmoduleupdate: {
    method: 'get',
    url: 'question/subject/module/update'
  },
  // 题库-模块-详情
  questionsubjectmoduledetail: {
    method: 'get',
    url: 'question/subject/module/detail'
  },
  // 查询单位开放科目
  questionsubjectopencompanyquery: {
    method: 'get',
    url: 'question/subject/open/company/query'
  },
  // 设置单位开放科目
  questionsubjectopencompanyset: {
    method: 'post',
    url: 'question/subject/open/company/set'
  },
  // 修改单位科目开放记录
  questionsubjectopencompanyupdate: {
    method: 'get',
    url: 'question/subject/open/company/update'
  },
  // 删除单位科目开放记录
  questionsubjectopencompanydelete: {
    method: 'get',
    url: 'question/subject/open/company/delete'
  },
  // 查询用户开放科目
  questionsubjectopenuidquery: {
    method: 'get',
    url: 'question/subject/open/uid/query'
  },
  // 设置用户开放科目
  questionsubjectopenuidset: {
    method: 'post',
    url: 'question/subject/open/uid/set'
  },
  // 删除用户科目开放记录
  questionsubjectopenuiddelete: {
    method: 'get',
    url: 'question/subject/open/uid/delete'
  },
  // 修改用户科目开放记录
  questionsubjectopenuidupdate: {
    method: 'get',
    url: 'question/subject/open/uid/update'
  },
  // 查询单位开放科目树
  questionsubjectopencompanytree: {
    method: 'get',
    url: 'question/subject/open/company/tree'
  },
  // 保存用户科目选择
  questionsubjectuidchooseedit: {
    method: 'get',
    url: 'question/subject/uid/choose/edit'
  },
  // 理论考试：列表
  theorytaskmanagelist: {
    method: 'get',
    url: 'theory/task/manage/list'
  },
  // 理论考试：开启或关闭任务
  theorytaskmanageupdateexamStatus: {
    method: 'get',
    url: 'theory/task/manage/update/examStatus'
  },
  // 理论考试：新增或编辑
  theorytaskmanageedit: {
    method: 'post',
    url: 'theory/task/manage/edit'
  },
  // 理论考试：任务详情
  theorytaskmanagedetail: {
    method: 'get',
    url: 'theory/task/manage/detail'
  },
  // 理论考试：仅编辑考试时间和答题时长
  theorytaskmanageupdate: {
    method: 'get',
    url: 'theory/task/manage/update'
  },
  // 理论考试：删除或批量删除
  theorytaskmanagedelete: {
    method: 'post',
    url: 'theory/task/manage/delete'
  },
  // 理论考试：学生列表
  theorytaskmanagestudentlist: {
    method: 'get',
    url: 'theory/task/manage/student/list'
  },
  // 试卷：发布或取消发布
  exampaperupdateState: {
    method: 'get',
    url: 'exampaper/updateState'
  },
  // 试卷：考试中-添加考生
  theorytaskmanageinsertstudent: {
    method: 'post',
    url: 'theory/task/manage/insert/student'
  },
  // 删除指定理论考试下的考生
  theorytaskmanagedeletestudent: {
    method: 'post',
    url: 'theory/task/manage/delete/student'
  },
  // 试卷：收卷-交卷
  theorystudenthandIdPapersave: {
    method: 'post',
    url: 'theory/student/handIdPaper/save'
  },
  // 试卷：学生-在线考试-提交试卷
  theorystudentsubmitmyPaper: {
    method: 'get',
    url: 'theory/student/submit/myPaper'
  },
  // 试卷：收卷-一键收卷
  theorystudentsubmitallPaper: {
    method: 'get',
    url: 'theory/student/submit/allPaper'
  },
  // 试卷：考试查询-考试情况
  theorystudentqueryTaskAnswer: {
    method: 'get',
    url: 'theory/student/queryTaskAnswer'
  },
  // 试卷：考试查询-客观题作答情况
  theorystudentqueryTaskObjectiveAnswer: {
    method: 'get',
    url: 'theory/student/queryTaskObjectiveAnswer'
  },
  // 试卷：考试查询-班级作答情况
  theorystudentqueryTaskClassAnswer: {
    method: 'get',
    url: 'theory/student/queryTaskClassAnswer'
  },
  // 试卷：批改-查看试卷-学生题型得分和正确率统计
  theorycorrectstudentqueryScoreAndRateOfCate: {
    method: 'get',
    url: 'theory/correct/student/queryScoreAndRateOfCate'
  },
  // 试卷：批改-学生-题目得分列表
  theorycorrectstudentqueryQuestionScoreList: {
    method: 'get',
    url: 'theory/correct/student/queryQuestionScoreList'
  },
  // 试卷：批改-主观题批阅
  theorycorrectsaveSubjectiveResult: {
    method: 'post',
    url: 'theory/correct/saveSubjectiveResult'
  },
  // 试卷：单个学生成绩发布
  theorystudentpublishOneScore: {
    method: 'get',
    url: 'theory/student/publishOneScore'
  },
  // 试卷： 一键发布成绩
  theorystudentpublishAllScore: {
    method: 'get',
    url: 'theory/student/publishAllScore'
  },
  // 培训： 编辑培训
  trainingtaskmanageedit: {
    method: 'post',
    url: 'training/task/manage/edit'
  },
  // 培训：列表
  trainingtaskmanagelist: {
    method: 'get',
    url: 'training/task/manage/list'
  },
  // 培训：开启或关闭任务
  trainingtaskmanageupdatestatus: {
    method: 'get',
    url: 'training/task/manage/update/status'
  },
  // 培训：删除或批量删除
  trainingtaskmanagedelete: {
    method: 'post',
    url: 'training/task/manage/delete'
  },
  // 培训：任务详情
  trainingtaskmanagedetail: {
    method: 'get',
    url: 'training/task/manage/detail'
  },
  // 培训：指定培训下学生-列表
  trainingtaskmanagestudentlist: {
    method: 'get',
    url: 'training/task/manage/student/list'
  },
  // 培训：移除考生
  trainingtaskmanagedeletestudent: {
    method: 'post',
    url: 'training/task/manage/delete/student'
  },
  // 培训：已发布-添加考生
  trainingtaskmanageinsertstudent: {
    method: 'post',
    url: 'training/task/manage/insert/student'
  },
  // 培训：审核学生报名
  trainingtaskapproveStudentJoin: {
    method: 'post',
    url: 'training/task/approveStudentJoin'
  },
  // 全部课程
  traincoursecodeAlllist: {
    method: 'get',
    url: 'train/course/codeAll/list'
  },
  // 修改学生培训通过状态
  trainingtaskupdateStuPassStatus: {
    method: 'post',
    url: 'training/task/updateStuPassStatus'
  },
  // 更新指定培训学生培训通过状态
  trainingtaskupdateAllUnPassStuPassStatus: {
    method: 'get',
    url: 'training/task/updateAllUnPassStuPassStatus'
  },
  // 成绩报告-错误详情分析
  theorycorrectstudentqueryErrorQuestionList: {
    method: 'get',
    url: 'theory/correct/student/queryErrorQuestionList'
  },
  // 试卷组卷-试卷题型查询
  questiontopaperquerypapercategorylist: {
    method: 'get',
    url: 'question/to/paper/querypapercategorylist'
  },
  // 试卷组卷-题量查询
  questiontopaperqueryQuestionNumByPaperIds: {
    method: 'post',
    url: 'question/to/paper/queryQuestionNumByPaperIds'
  },
  // 智能组卷-题量查询
  questiontopaperqueryQuestionNumByCategoryIds: {
    method: 'post',
    url: 'question/to/paper/queryQuestionNumByCategoryIds'
  },
  // 试卷组卷-保存（生成试卷）
  questiontopapergeneratePaperFromPaper: {
    method: 'post',
    url: 'question/to/paper/generatePaperFromPaper'
  },
  //智能组卷-保存（生成试卷）
  questiontopapergeneratePaperFromCategory: {
    method: 'post',
    url: 'question/to/paper/generatePaperFromCategory'
  },
  // 教学计划管理-列表
  teachingplansmanagelist: {
    method: 'get',
    url: 'teaching/plans/manage/list'
  },
  // 教学计划管理-编辑计划
  teachingplansmanageedit: {
    method: 'post',
    url: 'teaching/plans/manage/edit'
  },
  // 教学计划管理-任务详情
  teachingplansmanagedetail: {
    method: 'get',
    url: 'teaching/plans/manage/detail'
  },
  // 教学计划管理-开启或关闭任务
  teachingplansmanageupdatestatus: {
    method: 'get',
    url: 'teaching/plans/manage/update/status'
  },
  // 教学计划管理-删除或批量删除
  teachingplansmanagedelete: {
    method: 'post',
    url: 'teaching/plans/manage/delete'
  },
  // 资源分类管理:列表
  respubliccategorytree: {
    method: 'get',
    url: 'res/public/category/tree'
  },
  // 资源分类管理:新增
  respubliccategoryadd: {
    method: 'get',
    url: 'res/public/category/add'
  },
  // 资源分类管理:更新
  respubliccategoryupdate: {
    method: 'get',
    url: 'res/public/category/update'
  },
  // 资源分类管理:删除
  respubliccategorydelete: {
    method: 'get',
    url: 'res/public/category/delete'
  },
  // 管理部门列表
  managementlist: {
    method: 'get',
    url: 'management/list'
  },
  // 院区列表
  campuslist: {
    method: 'get',
    url: 'campus/list'
  },
  // 管理部门和科室关联全量保存
  managementdepartmentedit: {
    method: 'post',
    url: 'management/department/edit'
  },
  // 资源下载/时长设置
  respublicdownloadset: {
    method: 'post',
    url: 'res/public/download/set'
  },
  // 单位下人员类型列表
  companyuserTypelist: {
    method: 'get',
    url: 'company/userType/list'
  },
  //老师：职称
  userteachertitlelist: {
    method: 'get',
    url: 'user/teacher/title/list'
  },
  //根据用户类型id查询职务
  userpositionlist: {
    method: 'get',
    url: 'user/position/list'
  },
  //根据当前用户角色返回管理部门列表
  managementgetManagementListByRid: {
    method: 'get',
    url: 'management/getManagementListByRid'
  },
  //根据当前用户角色返回管理部门列表
  respubliccategoryquerylist: {
    method: 'get',
    url: 'res/public/category/query/list'
  },
  //某计划的配置项-编辑
  teachingitemmanageedit: {
    method: 'post',
    url: 'teaching/item/manage/edit'
  },
  //某计划的配置项-列表
  teachingitemmanagelist: {
    method: 'get',
    url: 'teaching/item/manage/list'
  },
  //某计划的配置项-删除
  teachingitemmanagedelete: {
    method: 'get',
    url: 'teaching/item/manage/delete'
  },
  //专科小组列表
  traininggrouplist: {
    method: 'get',
    url: 'training/group/list'
  },
  //专科小组编辑
  traininggroupedit: {
    method: 'post',
    url: 'training/group/edit'
  },
  //删除专科小组
  traininggroupdelete: {
    method: 'post',
    url: 'training/group/delete'
  },
  //专科小组-某专科小组管理员列表
  traininggroupmanagelist: {
    method: 'get',
    url: 'training/group/manage/list'
  },
  //专科小组-某专科小组组员列表
  traininggrouptraineelist: {
    method: 'get',
    url: 'training/group/trainee/list'
  },
  //专科小组-某专科小组添加管理员（增量）
  traininggroupmanageadd: {
    method: 'post',
    url: 'training/group/manage/add'
  },
  //专科小组-某专科小组删除管理员
  traininggroupmanagedelete: {
    method: 'post',
    url: 'training/group/manage/delete'
  },
  //专科小组-某专科小组添加组员（增量）
  traininggrouptraineeadd: {
    method: 'post',
    url: 'training/group/trainee/add'
  },
  //专科小组-某专科小组删除组员
  traininggrouptraineedelete: {
    method: 'post',
    url: 'training/group/trainee/delete'
  },
  //获取本单位能级列表
  companyuserenergyLevellist: {
    method: 'get',
    url: 'company/user/energyLevel/list'
  },
  //查询当前用户的可见范围
  visibilitylist: {
    method: 'get',
    url: 'visibility/list'
  },
  //查询当前用户所在专科小组列表
  traininggroupgetListByManageUid: {
    method: 'get',
    url: 'training/group/getListByManageUid'
  },
  //编辑完成标准
  trainingtaskmanageupdatePassStandard: {
    method: 'post',
    url: 'training/task/manage/updatePassStandard'
  },
  //院外主讲人人员列表
  trainingspeakermanagelist: {
    method: 'get',
    url: 'training/speaker/manage/list'
  },
  //编辑主讲人/负责人
  trainingtaskmanageupdateSpeaker: {
    method: 'post',
    url: 'training/task/manage/updateSpeaker'
  },
  //查询培训标准
  trainingtaskmanagequeryPassStandard: {
    method: 'get',
    url: 'training/task/manage/queryPassStandard'
  },
  //查询参与者类型
  commparaconfquerycklist: {
    method: 'get',
    url: 'commparaconf/query/ck/list'
  },
  //查询某培训下的院外主讲人
  trainingtaskmanagequeryOutSpeaker: {
    method: 'get',
    url: 'training/task/manage/queryOutSpeaker'
  },
  //编辑培训学员
  trainingtaskmanageupdateTrainee: {
    method: 'post',
    url: 'training/task/manage/updateTrainee'
  },
  //删除某培训下的培训学员
  trainingtaskmanagedeleteTrainee: {
    method: 'post',
    url: 'training/task/manage/deleteTrainee'
  },
  //获取二维码
  codeobtainQRCode: {
    method: 'get',
    url: 'code/obtain/QRCode'
  },
  //指定培训下-签到列表
  trainingofflinesignlist: {
    method: 'get',
    url: 'training/offline/sign/list'
  },
  //线上培训-指定培训下-学员资源签到列表
  trainingresourcesignlist: {
    method: 'get',
    url: 'training/resource/sign/list'
  },
  //指定培训下-修改学员签到状态
  trainingofflinesignupdatestatus: {
    method: 'get',
    url: 'training/offline/sign/update/status'
  },
  // 我的课程下章节列表（版本2）
  traincoursemychapterlist2: {
    method: 'get',
    url: 'train/course/my/chapter/list2'
  },
  // 查询课程下文档是否都设置了观看时长
  traincoursegetUnSetLookDurationResourceIdList: {
    method: 'get',
    url: 'train/course/getUnSetLookDurationResourceIdList'
  },
  //专科小组培训-统计列表
  traininggroupstatisticlist: {
    method: 'get',
    url: 'training/group/statistic/list'
  },
  //码上评-现场图片上传
  codeimageadd: {
    method: 'post',
    url: 'code/image/add'
  },
  //码上评-现场图片查询
  codeimageget: {
    method: 'get',
    url: 'code/image/get'
  },
  //按培训按科室统计列表
  trainingstatisticgetdepartlist: {
    method: 'get',
    url: 'training/statistic/get/depart/list'
  },
  // 按培训按能级统计列表
  trainingstatisticgetenergyLevellist: {
    method: 'get',
    url: 'training/statistic/get/energyLevel/list'
  },
  // 查询某用户总培训学分和总主讲学分
  trainingstudentgetStatisticCreditByUid: {
    method: 'get',
    url: 'training/student/getStatisticCreditByUid'
  },
  // 查询指定用户为主讲人的培训列表
  trainingtaskgetTrainingListBySpeakerUid: {
    method: 'get',
    url: 'training/task/getTrainingListBySpeakerUid'
  },
  // 发送培训催学通知
  trainingmessagesendTrainingTraineeStudyMessage: {
    method: 'get',
    url: 'training/message/sendTrainingTraineeStudyMessage'
  },
  // 更新码上评报告
  codeupdatereport2: {
    method: 'get',
    url: 'code/update/report2'
  },
  // 院外主讲人编辑
  trainingspeakermanageedit: {
    method: 'post',
    url: 'training/speaker/manage/edit'
  },
  // 调整院外主讲人状态
  trainingspeakermanageupdateStatus: {
    method: 'get',
    url: 'training/speaker/manage/updateStatus'
  },
  // 指定主讲人下培训列表
  trainingtaskgetTrainingListBySpeakerId: {
    method: 'get',
    url: 'training/task/getTrainingListBySpeakerId'
  },
  // 培训问卷调查记录列表
  teachevaltraininglist: {
    method: 'get',
    url: 'teach/eval/training/list'
  },
  // 指定relTableId下所有评论列表
  commentgetListByRelTableId: {
    method: 'get',
    url: 'comment/getListByRelTableId'
  },
  // 指定relTableId下所有评论列表导出
  commentgetListByRelTableIdexport: {
    method: 'get',
    url: 'comment/getListByRelTableId/export'
  },
  // 直播报名和取消报名
  liveapplicantupdateapply: {
    method: 'get',
    url: 'live/applicant/update/apply'
  },
  // 直播讲座详情
  livemanagedetail: {
    method: 'get',
    url: 'live/manage/detail'
  },
  // 校验直播码是否正确
  livemanagecheckliveCode: {
    method: 'get',
    url: 'live/manage/check/liveCode'
  },
  // 查询用户是否在直播间状态
  trtcroomgetUserRoomStatus: {
    method: 'get',
    url: 'trtc/room/getUserRoomStatus'
  },
  // 关闭某用户其他端的实时音视频
  trtcroomsendleaveRoomMsg: {
    method: 'get',
    url: 'trtc/room/send/leaveRoomMsg'
  },
  // 获取某场直播的临时用户uid
  usergettempUid: {
    method: 'get',
    url: 'user/get/tempUid'
  },
  // 获取直播间某个观众
  trtcroomuserInRoomone: {
    method: 'get',
    url: 'trtc/room/userInRoom/one'
  },
  // 发送消息
  livemsgsend: {
    method: 'get',
    url: 'live/msg/send'
  },
  // 获取某场直播的消息列表
  livemsglist: {
    method: 'get',
    url: 'live/msg/list'
  },
  // 主讲人结束某直播下某课程表
  livemanagespeakeroverschedule: {
    method: 'get',
    url: 'live/manage/speaker/over/schedule'
  },
  // 获取直播间某个观众
  trtcroomuserInRoomone: {
    method: 'get',
    url: 'trtc/room/userInRoom/one'
  },
  // 主讲人开启某观众的麦克风权限
  trtcroomupdatephoneAndVideoSet: {
    method: 'get',
    url: 'trtc/room/update/phoneAndVideoSet'
  },
  // 获取直播间观众列表
  trtcroomuserInRoomlist: {
    method: 'get',
    url: 'trtc/room/userInRoom/list'
  },
  // 直播讲座详情
  livemanagedetail: {
    method: 'get',
    url: 'live/manage/detail'
  },
  // 主讲人开启某观众的麦克风权限
  trtcroomupdatephoneAndVideoSet: {
    method: 'get',
    url: 'trtc/room/update/phoneAndVideoSet'
  },
  // 获取某直播讲座下某课程表的课程回放
  livemanageschedulevideolist: {
    method: 'get',
    url: 'live/manage/schedule/video/list'
  },
  // 发送消息
  livemsgsend: {
    method: 'get',
    url: 'live/msg/send'
  },
  // 主讲人结束某直播下某课程表
  livemanagespeakeroverschedule: {
    method: 'get',
    url: 'live/manage/speaker/over/schedule'
  },
  // 获取直播间某个观众
  trtcroomuserInRoomone: {
    method: 'get',
    url: 'trtc/room/userInRoom/one'
  },
  // 主讲人开启某观众的麦克风权限
  trtcroomupdatephoneAndVideoSet: {
    method: 'get',
    url: 'trtc/room/update/phoneAndVideoSet'
  },
  //  excel模板下载
  questiondownloadtemplate: {
    method: 'get',
    url: 'question/download/template'
  },
  // 编辑评分者和考生
  codeteacherupdate: {
    method: 'post',
    url: 'code/teacher/update'
  },
  // 试卷和题目word模版示例和模版文件地址查询
  commparaconfqueryDetail: {
    method: 'get',
    url: 'commparaconf/queryDetail'
  },
  //  word模版题目导入
  questionAndPaperquestionimport: {
    method: 'post',
    url: 'questionAndPaper/question/import'
  },
  // 操作考核短信通知
  codemessagesendPublishMessage: {
    method: 'get',
    url: 'code/message/sendPublishMessage'
  },
  // 理论考试短信通知
  theorymessagesendTheoryExamPublishMessage: {
    method: 'get',
    url: 'theory/message/sendTheoryExamPublishMessage'
  },
  // 模拟训练短信通知
  theorymessagesendTheoryTrainPublishMessage: {
    method: 'get',
    url: 'theory/message/sendTheoryTrainPublishMessage'
  },
  // AI出题-单选题
  modelquestiongeneratesinglechoice: {
    method: 'post',
    url: 'model/question/generate-single-choice'
  },
  // AI出题-多选题
  modelquestiongeneratemultichoice: {
    method: 'post',
    url: 'model/question/generate-multi-choice'
  },
  // AI出题/整理题目-统一接口
  modelquestionai: {
    method: 'post',
    url: 'model/question/ai'
  },
  // 批量题目保存
  questionAndPaperquestionadd: {
    method: 'post',
    url: 'questionAndPaper/question/add'
  },
  // 实习生单位列表
  studentschoollist: {
    method: 'get',
    url: 'student/school/list'
  },
  // 实习生单位列表
  planUserdownloadtemplate: {
    method: 'get',
    url: 'planUser/download/template'
  },
  //  最满意实习生评价记录列表
  planbeststurecordlist: {
    method: 'get',
    url: 'plan/best/stu/record/list'
  },
  //  最满意实习生评价统计列表
  planbeststustatisticlist: {
    method: 'get',
    url: 'plan/best/stu/statistic/list'
  },
  //  最满意带教老师评价记录列表
  planbesttearecordlist: {
    method: 'get',
    url: 'plan/best/tea/record/list'
  },
  //  最满意带教老师评价统计列表
  planbestteastatisticlist: {
    method: 'get',
    url: 'plan/best/tea/statistic/list'
  },
  //  实习计划-人员导入模版导入
  planUsertemplateimport: {
    method: 'post',
    url: 'planUser/template/import'
  },
  //  指定实习计划下志愿活动列表
  planactivitiesmanagelist: {
    method: 'get',
    url: 'plan/activities/manage/list'
  },
  //  编辑志愿活动
  planactivitiesmanageedit: {
    method: 'post',
    url: 'plan/activities/manage/edit'
  },
  //   删除志愿活动
  planactivitiesmanagedelete: {
    method: 'post',
    url: 'plan/activities/manage/delete'
  },
  //   某志愿活动下实习人员列表
  planactivitiesstudentlist: {
    method: 'get',
    url: 'plan/activities/student/list'
  },
  // 某志愿活动下添加人员（增量）
  planactivitiesstudentadd: {
    method: 'post',
    url: 'plan/activities/student/add'
  },
  // 某志愿活动下删除人员
  planactivitiesstudentdelete: {
    method: 'post',
    url: 'plan/activities/student/delete'
  },
  // 教学计划：管理列表
  plantrainingmanagelist: {
    method: 'get',
    url: 'plan/training/manage/list'
  },
  // 教学计划：科室编辑
  plantrainingdepartedit: {
    method: 'post',
    url: 'plan/training/depart/edit'
  },
  // 教学计划：删除
  plantrainingmanagedelete: {
    method: 'get',
    url: 'plan/training/manage/delete'
  },
  // 教学计划：详情
  plantrainingmanagedetail: {
    method: 'get',
    url: 'plan/training/manage/detail'
  },
  // 教学计划：管理部门审批
  plantrainingmanageapproval: {
    method: 'get',
    url: 'plan/training/manage/approval'
  },
  // 科室实习生请销假列表
  planleavedepartlist: {
    method: 'get',
    url: 'plan/leave/depart/list'
  },
  // 管理部门请销假列表
  planleavemanagelist: {
    method: 'get',
    url: 'plan/leave/manage/list'
  },
  // 请销假列表详情
  planleavemanagedetail: {
    method: 'get',
    url: 'plan/leave/manage/detail'
  },
  // 请销假审批
  planleavemanageapproval: {
    method: 'get',
    url: 'plan/leave/manage/approval'
  },
  // 培训-现场图片查询
  trainingtaskimageget: {
    method: 'get',
    url: 'training/task/image/get'
  },
  // 培训-现场图片上传
  trainingtaskimageadd: {
    method: 'post',
    url: 'training/task/image/add'
  },
  // 考试-现场图片查询
  theorytaskimageget: {
    method: 'get',
    url: 'theory/task/image/get'
  },
  // 考试-现场图片上传
  theorytaskimageadd: {
    method: 'post',
    url: 'theory/task/image/add'
  },
  // 成绩报告-题目选项统计
  theorycorrectstudentqueryAllQuestionItemList: {
    method: 'get',
    url: 'theory/correct/student/queryAllQuestionItemList'
  },
  //  实习人员-分组更改
  planUsergroupupdate: {
    method: 'post',
    url: 'planUser/group/update'
  },
  //   批量调整题目类别
  questioncategoryupdate: {
    method: 'post',
    url: 'question/category/update'
  },
  //  修改培训结束时间
  trainingtaskmanageupdate: {
    method: 'get',
    url: 'training/task/manage/update'
  },
  //  常用培训地点查询
  trainingtaskqueryaddresslist: {
    method: 'get',
    url: 'training/task/query/address/list'
  },
  //  获取系统当前时间戳
  trainingtaskgetcurrentTime: {
    method: 'get',
    url: 'training/task/get/currentTime'
  },
  // 资源统计
  respublicquerystatistic: {
    method: 'get',
    url: 'res/public/query/statistic'
  },
  // 用户统计
  userdailyactivequerystatistic: {
    method: 'get',
    url: 'user/daily/active/query/statistic'
  },
  // 培训任务统计
  trainingtaskquerystatistic: {
    method: 'get',
    url: 'training/task/query/statistic'
  },
  // 理论考核和模拟训练统计
  theorytaskquerystatistic: {
    method: 'get',
    url: 'theory/task/query/statistic'
  },
  // 操作考核统计
  codequerystatistic: {
    method: 'get',
    url: 'code/query/statistic'
  },
  // 实习生-最满意带教老师统计
  planbestteaquerystatistic: {
    method: 'get',
    url: 'plan/best/tea/query/statistic'
  },
  // 实习生-最满意带教学生统计
  planbeststuquerystatistic: {
    method: 'get',
    url: 'plan/best/stu/query/statistic'
  },
  // 实习生-实习任务列表
  plansimplelist: {
    method: 'get',
    url: 'plan/simple/list'
  },
  //实习生-请销假统计
  planleavequerystatistic: {
    method: 'get',
    url: 'plan/leave/query/statistic'
  },
  //实习生-志愿者活动统计
  planactivitiesquerystatistic: {
    method: 'get',
    url: 'plan/activities/query/statistic'
  },
  //全系统分类查询列表
  casesystemclassificationlist: {
    method: 'get',
    url: 'case/system/classification/list'
  },
  // 语音转文本
  asrvoiceToTexttext: {
    method: 'post',
    url: 'asr/voiceToText/text'
  },
  // 语音转文本2
  asrvoiceToTexttext2: {
    method: 'post',
    url: 'asr/voiceToText/text2'
  },
  // 文本转语音
  ttstextToVoicevoiceFile: {
    method: 'get',
    url: 'tts/textToVoice/voiceFile'
  },
  // 查询最近一次的虚拟问诊
  modelchatquerylatest: {
    method: 'get',
    url: 'model/chat/query/latest'
  },
  // 查询某用户虚拟问诊记录列表
  modelchatscorelist: {
    method: 'get',
    url: 'model/chat/score/list'
  },
  // 查询某用户虚拟问诊记录列表
  modelchatscoresimpleList: {
    method: 'get',
    url: 'model/chat/score/simpleList'
  },
  // 结束问诊（提交诊断结果）
  modelchatover: {
    method: 'post',
    url: 'model/chat/over'
  },
  // 开始问诊
  modelchatstart: {
    method: 'get',
    url: 'model/chat/start'
  },
  // 学科列表
  subjectList: {
    method: 'get',
    url: 'subject/list'
  },
  // 发送对话
  modelchatsend: {
    method: 'post',
    url: 'model/chat/send'
  },
  // 查询某用户所有对话列表
  modelchatmsglist: {
    method: 'get',
    url: 'model/chat/msg/list'
  },
  // 问诊任务：学生任务列表
  consultationtaskstudentlist: {
    method: 'get',
    url: 'consultation/task/student/list'
  },
  // 问诊任务：学生任务详情
  consultationtaskstudentdetail: {
    method: 'get',
    url: 'consultation/task/student/detail'
  },
  // 问诊任务：查询指定任务下某学生报告
  consultationtaskstudentreportdetail: {
    method: 'get',
    url: 'consultation/task/student/report/detail'
  },
  // 问诊任务：生成或更新某任务下指定学生的报告
  consultationtaskstudentreportupdate: {
    method: 'get',
    url: 'consultation/task/student/report/update'
  },
  // word试卷导入-获取解析结果
  apipaperparse: {
    method: 'post',
    url: 'api/paper/parse'
  },
  // 查询待审批个数
  planleaveunDealcount: {
    method: 'get',
    url: 'plan/leave/unDeal/count'
  },
  // 一键批改
  theorystudentupdateautoScoreByTheoryIdAndUid: {
    method: 'get',
    url: 'theory/student/update/autoScoreByTheoryIdAndUid'
  },
  spPaymentEdit: {// 薪酬财务报账 - 编辑
    method: 'post',
    url: 'api/sp/month/payment/edit'
  },
  spPaymentDelete: {// 薪酬财务报账 - 删除
    method: 'get',
    url: 'api/sp/month/payment/delete'
  },
  spPaymentDetail: {// 薪酬财务报账 - 详情
    method: 'get',
    url: 'api/sp/month/payment/detail'
  },
  spPaymentGenerate: {// 薪酬财务报账 - 生成月账单
    method: 'get',
    url: 'api/sp/month/payment/generate'
  },
  spUpdateStatus: {// 薪酬财务报账 - 批量修改状态
    method: 'get',
    url: 'api/sp/month/payment/updateStatus'
  },
  spOfflineEdit: {// 线下薪酬填报 - 编辑
    method: 'post',
    url: 'api/sp/offline/payment/edit'
  },
  spOfflineDelete: { // 线下薪酬 - 删除
    method: 'get',
    url: 'api/sp/offline/payment/delete'
  },
  spOfflineDetail: {// 线下薪酬 - 详情
    method: 'get',
    url: 'api/sp/offline/payment/detail'
  },
  simpleList: {// 根据用户名搜索SPuid
    method: 'get',
    url: 'sp/simple/list'
  },
  virtualList: {// 虚拟仿真 - 成绩列表
    method: 'get',
    url: 'api/virtual/project/score/list'
  },
  virtualDetail: {// 虚拟仿真 - 成绩详情
    method: 'get',
    url: 'api/virtual/project/score/detail'
  },
  oscemanagecenterexamoverset: {//  结束考试
    method: 'get',
    url: 'oscemanagecenter/exam/over/set'
  },
  oscereportupdate: {// 更新报告
    method: 'get',
    url: 'osce/report/update'
  },
  theorytaskmanageupdateopenscorequery: {// 开放成绩报告
    method: 'get',
    url: 'theory/task/manage/update/openScoreQuery'
  },
  planleaveexport: {//实习生-请销假导出
    method: 'get',
    url: 'plan/leave/depart/list/export'
  }
}
export default CONTACT_API
